// 过滤器和过滤策略
export const mixinsTest = {
        data() {
            return {
                loading_tempalte: false,
                select_notify_template: '',
                tempalte_arr: [],
                template_name: '',
                default_q_order_sort: '',
                default_q_order_type: '',
                q_dft_keyword: [],
                checkAll: false,
                checkedCities: ['subject', "hdr_from", "to", "cc", "reply-to", "sender", "filename", "body"],
                policy_priv: [],
                isIndeterminate: false,
                // filter_name
                filter_name: "",
                filter_describe: "",
                // A链接扫描
                chkalink: false,
                alink_out_relation: 1,
                alink_name: "alinktag",
                alink_namee0: [],
                alink_relation: 1,
                alink_relationn0: [],
                alink_type: 0,
                alink_typee0: [],
                alink_regex: "",
                alinkList: [{
                    id: 1,

                    alinkList1: [{
                        id: 1,

                        alink_name: "alinktag",
                        alink_namee0: [],
                        alink_relation: 1,
                        alink_relationn0: [],
                        alink_type: 0,
                        alink_typee0: "",
                        alink_regex: "",
                    }, ],
                }, ],
                // 内容策略
                chkcontent: true,
                rootcontrelation: 1,
                content_out_relation: [],

                content_name: this.content_name_default,
                content_name_default: "",
                content_namee0: [],
                content_relation: 1,
                content_relationn0: [],
                content_relation2: 1,
                content_relationn2: [],
                content_type: 1,
                content_typee0: [],
                content_type2: 0,
                content_typee2: [],
                regex: "",
                content_exist: 1,
                content_existt: [],
                content_matchcn: "",
                content_match: 1,
                content_matchh: [],
                header_key: "",
                score: "",
                contentList: [{
                    id: 1,
                    content_out_relation: 1,

                    contentList1: [{
                        id: 1,
                        score: "",
                        content_name: this.content_name_default,
                        content_namee0: [],
                        content_relation: 1,
                        content_relation2: 1,
                        content_relationn0: [],
                        content_relationn2: [],
                        content_type: 1,
                        content_type2: 0,
                        content_typee0: "",
                        content_typee2: "",
                        content_exist: 1,
                        content_existt: [],
                        content_matchcn: "",
                        content_match: 1,
                        content_matchh: [],
                        header_key: "",
                        policy_priv: [],
                        checkedCities: this.q_dft_keyword,

                    }, ],
                }, ],
                // 条件策略
                q_spf_result: [],
                spf_result: '',
                chkcondition: false,
                rootcondrelation: 1,
                condition_relation: [],
                condition_name: "msgsize",
                condition_namee0: [],
                msgsize_type: 1,
                msgsize_typee0: [],
                msgsize: "",
                msgsizee0: "",
                sublen_type: "",
                sublen_typee: [],

                msgsize_unit: "KB",
                change_one: true,
                change_two: true,
                change_three: true,
                network_type: "unknown",
                network_type00: [],
                white_type: 0,
                // whetherr: [],
                change_network: false,
                tiaoa: [{
                    id: 1,
                    condition_relation: 1,

                    tiaob: [{
                        id: 1,
                        msgsize_unit: "KB",
                        options: [{
                                value: "KB",
                                label: "KB",
                            },
                            {
                                value: "MB",
                                label: "MB",
                            },
                            {
                                value: "B",
                                label: "B",
                            },
                        ],
                        white_type: 0,
                        white_typee: [{
                                value: 1,
                                label: "是",
                            },
                            {
                                value: 0,
                                label: "否",
                            },
                        ],
                        network_type: "unknown",
                        network_type00: [],
                        condition_namee0: [],
                        condition_name: "msgsize",
                        msgsize_type: 1,
                        msgsize_typee0: [],
                        // sublen_type: 1,
                        sublen_typee: [],
                        msgsize0: "",
                        msgsizee0: "",
                    }, ],
                }, ],
                white_typee: [],
                xian2: false,
                xian3: 0,
                xian1: true,
            };
        },

        created() {



        },

        mounted() {

        },

        methods: {
            // 模板添加
            change_template(val) {
                console.log(val)
                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                // console.log(sid);
                this.loading_tempalte = true;

                this.$axios
                    .get("/api/adm/cgi/bspam.cgi", {
                        params: {
                            __mode: "load_one_template",
                            sid: sid,
                            template_name: val,
                        },
                    })
                    .then((res) => {
                        console.log(res);
                        this.loading_tempalte = false;

                        if (!res) {
                            this.loading_tempalte = false;
                        } else if (!res.data.fmstatus) {
                            alert(res.data);
                        } else if (res.data.fmstatus.code == "2") {
                            this.$message({
                                type: "error",
                                message: `${res.data.fmstatus.errmsg}`,
                            });

                        } else if (res.data.fmstatus.code == "3") {
                            alert(res.data.fmstatus.errmsg);
                            this.$router.push({
                                name: "login",
                            });
                        } else {

                            this.notify_inc_eml = res.data.ret.NOTIFY_INC_EML == 1 ? true : false;

                            this.notify_envfrom = res.data.ret.NOTIFY_ENVFROM;
                            this.notify_subject = res.data.ret.NOTIFY_SUBJECT;
                            this.notify_body_template = res.data.ret.NOTIFY_BODY_TEMPALTE;
                        }
                    });
            },
            //  启用内容策略
            content_judge1(a) {
                console.log(a, 'diaoyong');
                if (a == "attach_body" || a == "ocr_body" || a == "body") {
                    return true;
                } else if (a == "peer_ip" || a == "env_from" || a == "env_rcpt" || a == "hdr_name") {
                    return true;
                } else if (a == "header" || a == "mime_hdr") {
                    return true;
                } else if (a == "ptr") {
                    return true;
                } else if (a == "keyword") {

                    return true;
                } else {
                    return true;
                }
            },
            content_judge2(a) {
                // console.log(a, b)
                if (a == "attach_body" || a == "ocr_body" || a == "body") {
                    return false;
                } else if (a == "peer_ip" || a == "env_from" || a == "env_rcpt" || a == "hdr_name") {
                    return false;
                } else if (a == "header" || a == "mime_hdr") {
                    return true;
                } else if (a == "ptr") {
                    return false;
                } else {
                    return false;
                }
            },

            content_judge3(a) {
                // console.log(a, b)
                if (a == "attach_body" || a == "ocr_body" || a == "body") {
                    return false;
                } else if (a == "peer_ip" || a == "env_from" || a == "env_rcpt" || a == "hdr_name") {
                    return false;
                } else if (a == "header" || a == "mime_hdr") {
                    return true;
                } else if (a == "ptr") {
                    return true;
                } else {
                    return false;
                }
            },
            content_judge4(a, b) {
                // console.log(a, b)
                if ((a == "attach_body" || a == "ocr_body" || a == "body") && b == 0) {
                    return true;
                } else if (a == "peer_ip" || a == "env_from" || a == "env_rcpt" || a == "hdr_name") {
                    return false;
                } else if (a == "header" || a == "mime_hdr") {
                    return false;
                } else if (a == "ptr") {
                    return false;
                } else {
                    return false;
                }
            },
            content_judge5(a, b) {
                // console.log(a, b)
                if (a == "attach_body" || a == "ocr_body" || a == "body") {
                    return false;
                } else if (
                    (a == "peer_ip" || a == "env_from" || a == "env_rcpt" || a == "hdr_name") &&
                    b == 1
                ) {
                    return true;
                } else if (a == "header" || a == "mime_hdr") {
                    return false;
                } else if (a == "ptr") {
                    return false;
                } else {
                    return false;
                }
            },
            content_judge_score(a) {
                // console.log(a);
                if (a == 2) {
                    return true;
                }
            },
            content_judge_keyword(a) {

                if (a == 'keyword') {

                    return true;

                } else {
                    return false;

                }
            },
            content_judge_keyword_or(a) {
                // console.log(a 
                if (a == 'keyword') {
                    return false;

                } else {
                    return true;

                }
            },
            // 启用条件策略
            condition_judge1(a) {
                // console.log(a);

                if (a == "bodylen" || a == "msgsize" || a == "sublen" || a == "attsize") {
                    return true;
                } else if (a == "network") {
                    return true;
                } else if (a == "white") {
                    return true;
                } else {
                    return true;
                }
            },
            condition_judge2(a) {
                // console.log(a);

                if (
                    a == "envtonotlocalnum" ||
                    a == "hdrbsnum" ||
                    a == "sublen" ||
                    a == "hdrnotlocalnum" ||
                    a == "bccnum" ||
                    a == "envbsnum"
                ) {
                    return false;
                } else if (a == "network" || a == "spfres") {
                    return false;
                } else if (a == "white") {
                    return false;
                } else {
                    return true;
                }
            },
            condition_judge_big(a) {
                // console.log(a);

                if (
                    a == "envtonotlocalnum" ||
                    a == "hdrbsnum" ||
                    a == "sublen" ||
                    a == "hdrnotlocalnum" ||
                    a == "bccnum" ||
                    a == "envbsnum"
                ) {
                    return true;
                } else if (a == "network") {
                    return false;
                } else if (a == "white") {
                    return false;
                } else {
                    return false;
                }
            },
            condition_judge3(a) {
                // console.log(a);

                if (a == "bodylen" || a == "msgsize" || a == "sublen" || a == "attsize") {
                    return true;
                } else if (a == "network" || a == "spfres") {
                    return false;
                } else if (a == "white") {
                    return false;
                } else {
                    return true;
                }
            },
            condition_judge4(a) {
                // console.log(a);

                if (a == "bodylen" || a == "msgsize" || a == "sublen" || a == "attsize") {
                    return true;
                } else if (a == "network") {
                    return false;
                } else if (a == "white") {
                    return false;
                } else {
                    return false;
                }
            },
            condition_judge5(a) {
                // console.log(a);

                if (a == "bodylen" || a == "msgsize" || a == "sublen" || a == "attsize") {
                    return false;
                } else if (a == "network") {
                    return true;
                } else if (a == "white") {
                    return false;
                } else {
                    return false;
                }
            },
            condition_judge6(a) {
                // console.log(a);

                if (a == "bodylen" || a == "msgsize" || a == "sublen" || a == "attsize") {
                    return false;
                } else if (a == "network") {
                    return false;
                } else if (a == "white") {
                    return true;
                } else {
                    return false;
                }
            },
            condition_judge_spf(a) {

                if (a == "spfres") {
                    return true;
                } else {
                    return false;
                }

            },
            // 单选框选中
            change(a) {
                //   this.value = this.value == 0 ? 1 : 0;
                // console.log(a, '启动')
                this.chkcondition = a;
                // console.log(this.chkcondition);
            },
            change1(a) {
                //   this.value = this.value == 0 ? 1 : 0;
                // console.log(this.value)
                this.rootcondrelation = a;
                // console.log(this.rootcondrelation);
            },
            change3(a) {
                //   this.value = this.value == 0 ? 1 : 0;
                // console.log(this.value)
                this.chkcontent = a;
                // console.log(this.chkcontent);
            },
            change4(a) {
                //   this.value = this.value == 0 ? 1 : 0;
                // console.log(this.value)
                this.rootcontrelation = a;
                // console.log(this.rootcondrelation);
            },
            change5(a) {
                //   this.value = this.value == 0 ? 1 : 0;
                // console.log(this.value)
                this.chkalink = a;
                // console.log(this.rootcondrelation);
            },
            change6(a) {
                //   this.value = this.value == 0 ? 1 : 0;
                // console.log(this.value)
                this.alink_out_relation = a;
                // console.log(this.rootcondrelation);
            },
            // 条件块添加
            tiaojian_add1() {
                this.tiaoa.push({
                    id: this.tiaoa.length + 1,
                    // options: this.options,
                    condition_relation: 1,

                    tiaob: [{
                        id: 1,
                        condition_namee0: this.condition_namee0,
                        condition_name: this.condition_name,
                        msgsize_type: this.msgsize_type,
                        msgsize_typee0: this.msgsize_typee0,
                        msgsize: this.msgsize,
                        network_type: this.network_type00[0].value,
                        network_type00: this.network_type00,
                        white_type: this.white_type,
                        white_typee: this.white_typee,
                        options: this.options,
                        msgsize_unit: this.options[0].value,
                        // sublen_type: this.sublen_typee[0].value,
                        sublen_typee: this.sublen_typee,
                    }, ],
                });
                console.log(this.tiaoa, "添加时候，1");
            },
            // 条件块删除
            deleteRow(index) {
                if (this.tiaoa.length <= 1) {
                    alert("只有一条数据,不可以删除");
                } else {
                    this.tiaoa.splice(index - 1, 1);
                    this.tiaoa.forEach((ele) => {
                        console.log(ele);
                        if (ele.id > index) {
                            ele.id = ele.id - 1;
                        }
                    });
                }
            },
            // 条件块添加2
            tiaojian_add2(id) {
                this.tiaoa.forEach((ele) => {
                    // console.log(ele)
                    if (id == ele.id) {
                        // secondId = ele.tiaob.length ,
                        ele.tiaob.push({
                            id: ele.tiaob.length + 1,
                            condition_namee0: this.condition_namee0,
                            condition_name: this.condition_name,
                            msgsize_type: this.msgsize_type,
                            msgsize_typee0: this.msgsize_typee0,
                            msgsize0: this.msgsize0,
                            network_type: this.network_type00[0].value,
                            network_type00: this.network_type00,
                            white_type: this.white_type,
                            white_typee: this.white_typee,
                            options: this.options,
                            msgsize_unit: this.options[0].value,
                            // sublen_type: this.sublen_typee[0].value,
                            sublen_typee: this.sublen_typee,
                        });
                        // console.log(ele.tiaob, '添加时候，2');
                    }
                });
                // console.log(this.tiaoa, '添加时候，2');
            },
            // 条件块删除2
            deleteRow2(index1, index2) {
                console.log(index1, index2, "条件块2删除");
                console.log(this.tiaoa, "条件块22删除");
                if (this.tiaoa[index1 - 1].tiaob.length <= 1) {
                    alert("只有一条数据,不可以删除");
                } else {
                    this.tiaoa[index1 - 1].tiaob.splice(index2 - 1, 1);
                    this.tiaoa[index1 - 1].tiaob.forEach((item) => {
                        if (item.id > index2) {
                            item.id = item.id - 1;
                        }
                    });
                }
            },
            // 内容块添加
            content_add1() {
                this.contentList.push({
                    id: this.contentList.length + 1,
                    // options: this.options,
                    content_out_relation: 1,
                    contentList1: [{
                        id: 1,
                        content_name: this.content_name_default,
                        content_namee0: this.content_namee0,
                        content_relation: this.content_relation,
                        content_relation2: this.content_relation2,
                        content_relationn0: this.content_relationn0,
                        content_relationn2: this.content_relationn2,
                        content_type: this.content_type,
                        content_typee0: this.content_typee0,
                        content_type2: this.content_type2,
                        content_typee2: this.content_typee2,
                        regex: this.regex,

                        content_exist: this.content_exist,
                        content_existt: this.content_existt,
                        content_matchcn: this.content_matchcn,
                        content_match: this.content_match,
                        content_matchh: this.content_matchh,
                        header_key: this.header_key,
                        score: this.score,
                        policy_priv: this.policy_priv,
                        checkedCities: this.q_dft_keyword,
                    }, ],
                });
                console.log(this.contentList);
            },
            // 内容块删除
            deleteRow3(index) {
                if (this.contentList.length <= 1) {
                    alert("只有一条数据,不可以删除");
                } else {
                    this.contentList.splice(index - 1, 1);
                    this.contentList.forEach((ele) => {
                        // console.log(ele)
                        if (ele.id > index) {
                            ele.id = ele.id - 1;
                        }
                    });
                }
            },
            // 内容块添加2
            content_add2(id) {
                console.log(this.contentList, this.checkedCities, this.policy_priv)
                this.contentList.forEach((ele) => {
                    // console.log(ele)
                    if (id == ele.id) {
                        // secondId = ele.tiaob.length ,
                        ele.contentList1.push({
                            id: ele.contentList1.length + 1,
                            content_name: this.content_name_default,
                            content_namee0: this.content_namee0,
                            content_relation: this.content_relation,
                            content_relation2: this.content_relation2,
                            content_relationn2: this.content_relationn2,
                            content_type: this.content_type,
                            content_typee0: this.content_typee0,
                            content_type2: this.content_type2,
                            content_typee2: this.content_typee2,
                            regex: this.regex,
                            content_exist: this.content_exist,
                            content_existt: this.content_existt,
                            content_matchcn: this.content_matchcn,
                            content_match: this.content_match,
                            content_matchh: this.content_matchh,
                            header_key: this.header_key,
                            score: this.score,
                            policy_priv: this.policy_priv,
                            checkedCities: this.q_dft_keyword,
                        });
                    }
                });
                console.log(this.contentList)
            },
            // 内容块删除2
            deleteRow4(index1, index2) {
                console.log(index1, index2, "内容块，2删除");

                if (this.contentList[index1 - 1].contentList1.length <= 1) {
                    alert("只有一条数据,不可以删除");
                } else {
                    this.contentList[index1 - 1].contentList1.splice(index2 - 1, 1);
                    this.contentList[index1 - 1].contentList1.forEach((item) => {
                        if (item.id > index2) {
                            item.id = item.id - 1;
                        }
                    });
                }
            },
            // A链接添加
            alink_add1() {
                this.alinkList.push({
                    id: this.alinkList.length + 1,
                    // options: this.options,
                    alink_out_relation: 1,
                    alinkList1: [{
                        id: 1,
                        alink_name: this.alink_name,
                        alink_namee0: this.alink_namee0,
                        alink_relation: this.alink_relation,
                        alink_relationn0: this.alink_relationn0,
                        alink_type: this.alink_type,
                        alink_typee0: this.alink_typee0,
                        alink_regex: this.alink_regex,
                    }, ],
                });
                // console.log(this.tiaoa);
            },
            // A链接删除
            deleteRow5(index) {
                if (this.alinkList.length <= 1) {
                    alert("只有一条数据,不可以删除");
                } else {
                    this.alinkList.splice(index - 1, 1);
                    this.alinkList.forEach((ele) => {
                        // console.log(ele)
                        if (ele.id > index) {
                            ele.id = ele.id - 1;
                        }
                    });
                }
            },
            // A链接添加2
            alink_add2(id) {
                this.alinkList.forEach((ele) => {
                    // console.log(ele)
                    if (id == ele.id) {
                        // secondId = ele.tiaob.length ,
                        ele.alinkList1.push({
                            id: ele.alinkList1.length + 1,
                            alink_name: this.alink_name,
                            alink_namee0: this.alink_namee0,
                            alink_relation: this.alink_relation,
                            alink_relationn0: this.alink_relationn0,
                            alink_type: this.alink_type,
                            alink_typee0: this.alink_typee0,
                            alink_regex: this.alink_regex,
                        });
                    }
                });
            },
            // A链接删除2
            deleteRow6(index1, index2) {
                if (this.alinkList[index1 - 1].alinkList1.length <= 1) {
                    alert("只有一条数据,不可以删除");
                } else {
                    this.alinkList[index1 - 1].alinkList1.splice(index2 - 1, 1);
                    this.alinkList[index1 - 1].alinkList1.forEach((item) => {
                        if (item.id > index2) {
                            item.id = item.id - 1;
                        }
                    });
                }
            },
            // 数据
            // 加载
            getFileList() {
                this.loading = true;

                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                // console.log(sid);

                this.$axios
                    .get("/api/adm/cgi/aspam.cgi", {
                        params: {
                            __mode: "load_filter_list",
                            sid: sid,
                        },
                    })
                    .then((res) => {
                        console.log(res);

                        if (!res) {
                            this.loading = false;
                        } else if (!res.data.fmstatus) {
                            alert(res.data);
                        } else if (res.data.fmstatus.code == "1") {
                            alert(res.data.fmstatus.errmsg);
                            this.loading = false;
                        } else if (res.data.fmstatus.code == "2") {
                            alert(res.data.fmstatus.errmsg);
                            this.loading = false;
                        } else if (res.data.fmstatus.code == "3") {
                            alert(res.data.fmstatus.errmsg);
                            this.$router.push({
                                name: "login",
                            });
                        } else {
                            this.loading = false;
                            this.fileList = res.data.ret.datalist;


                            this.show_macro_list = res.data.ret.SYS_CAN_SEE_MACRO_LIST;
                            // 条件策略
                            // this.condition_name0 = res.data.ret.q_condition_name[0].label;
                            this.condition_namee0 = res.data.ret.q_condition_name;
                            // this.msgsize_type0 = res.data.ret.q_condition_equal[0].label;
                            this.q_spf_result = res.data.ret.q_spf_result;
                            this.msgsize_typee0 = res.data.ret.q_condition_equal;
                            this.sublen_typee = res.data.ret.q_condition_equal2;

                            this.msgsize_unit = this.options[0].label;
                            this.network_type00 = res.data.ret.q_condition_network;
                            this.white_typee = res.data.ret.q_condition_white;
                            // console.log(this.network_type00)

                            // 第一次

                            this.tiaoa[0].tiaob[0].condition_namee0 =
                                res.data.ret.q_condition_name;
                            // this.tiaoa[0].tiaob[0].condition_name0 =
                            //     res.data.ret.q_condition_name[0].label;
                            this.tiaoa[0].tiaob[0].network_type00 =
                                res.data.ret.q_condition_network;
                            this.tiaoa[0].tiaob[0].msgsize_typee0 =
                                res.data.ret.q_condition_equal;
                            this.tiaoa[0].tiaob[0].sublen_typee =
                                res.data.ret.q_condition_equal2;
                            // this.tiaoa[0].tiaob[0].msgsize_type0 =
                            //     res.data.ret.q_condition_equal[0].label;
                            // 内容策略
                            this.content_name_default = res.data.ret.q_content_name[0].value;
                            this.content_namee0 = res.data.ret.q_content_name;

                            this.content_relationn0 = res.data.ret.q_content_relation;
                            this.content_relationn2 = res.data.ret.q_content_relation2;

                            // this.content_type0 = res.data.ret.q_content_type[0].label; content_exist: '',

                            this.content_typee0 = res.data.ret.q_content_type;
                            this.content_typee2 = res.data.ret.q_content_type2;
                            this.content_existt = res.data.ret.q_content_exist;
                            this.content_matchh = res.data.ret.q_content_match;
                            // 第一次
                            this.contentList[0].contentList1[0].content_namee0 =
                                res.data.ret.q_content_name;
                            this.policy_priv = res.data.ret.q_keyword_type;
                            this.contentList[0].contentList1[0].policy_priv = res.data.ret.q_keyword_type;
                            this.q_dft_keyword = res.data.ret.q_dft_keyword;
                            console.log(this.q_dft_keyword)
                            this.contentList[0].contentList1[0].content_relationn0 =
                                res.data.ret.q_content_relation;
                            this.contentList[0].contentList1[0].content_relationn2 =
                                res.data.ret.q_content_relation2;
                            this.contentList[0].contentList1[0].content_typee0 =
                                res.data.ret.q_content_type;
                            this.contentList[0].contentList1[0].content_typee2 =
                                res.data.ret.q_content_type2;
                            this.contentList[0].contentList1[0].content_existt =
                                res.data.ret.q_content_exist;
                            this.contentList[0].contentList1[0].content_matchh =
                                res.data.ret.q_content_match;
                            // this.contentList[0].contentList1[0].content_type0 =
                            //     res.data.ret.q_content_type[0].label;
                            // A链接
                            // this.alink_name0 = res.data.ret.q_alink_name[0].label;
                            this.alink_namee0 = res.data.ret.q_alink_name;

                            // this.alink_relation0 = res.data.ret.q_content_relation[0].label;
                            this.alink_relationn0 = res.data.ret.q_content_relation;

                            this.alink_typee0 = res.data.ret.q_content_type;
                            // 第一次
                            this.alinkList[0].alinkList1[0].alink_namee0 =
                                res.data.ret.q_alink_name;

                            this.alinkList[0].alinkList1[0].alink_relationn0 =
                                res.data.ret.q_content_relation;

                            this.alinkList[0].alinkList1[0].alink_typee0 =
                                res.data.ret.q_content_type;
                        }
                    });
            },
            //
            save_one() {
                this.save1();
            },

            // 保存
            save1() {
                // this.xian2 = false;
                // this.tanchu = false;
                // this.xian1 = true;
                this.$save_hint_test();
                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                let a = this.tiaoa;
                // 条件策略
                let multis = [];
                for (let i = 0; i < a.length; i++) {
                    let condition = [];
                    for (let v = 0; v < a[i].tiaob.length; v++) {
                        let condition_select_first = a[i].tiaob[v].condition_name;
                        console.log(condition_select_first);
                        if (condition_select_first == "network") {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,
                                network_type: a[i].tiaob[v].network_type,
                            });
                        } else if (condition_select_first == "white") {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,
                                white_type: a[i].tiaob[v].white_type,
                            });
                        } else if (condition_select_first == "spfres") {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,
                                spf_condition: a[i].tiaob[v].spf_result,
                            });
                        } else if (
                            condition_select_first == "bodylen" ||
                            condition_select_first == "msgsize" ||
                            condition_select_first == "attsize"
                        ) {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,

                                msgsize_type: a[i].tiaob[v].msgsize_type,
                                msgsize: a[i].tiaob[v].msgsize,
                                msgsize_unit: a[i].tiaob[v].msgsize_unit,
                                // network_type: a[i].tiaob[v].network_type0,
                                // whether: a[i].tiaob[v].whether,
                            });
                        } else if (condition_select_first == "sublen") {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,

                                msgsize_type: a[i].tiaob[v].msgsize_type,
                                msgsize: a[i].tiaob[v].msgsize,
                                msgsize_unit: a[i].tiaob[v].msgsize_unit,
                                // network_type: a[i].tiaob[v].network_type0,
                                // whether: a[i].tiaob[v].whether,
                            });
                        } else if (
                            a == "envtonotlocalnum" ||
                            a == "hdrbsnum" ||
                            a == "hdrnotlocalnum" ||
                            a == "bccnum" ||
                            a == "envbsnum"
                        ) {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,

                                msgsize_type: a[i].tiaob[v].msgsize_type,
                                msgsize: a[i].tiaob[v].msgsize,
                                // msgsize_unit: a[i].tiaob[v].msgsize_unit0,
                            });
                        } else {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,

                                msgsize_type: a[i].tiaob[v].msgsize_type,
                                msgsize: a[i].tiaob[v].msgsize,
                                // msgsize_unit: a[i].tiaob[v].msgsize_unit0,
                            });
                        }
                    }
                    multis.push({
                        // id: a[i].id,
                        condition_relation: a[i].condition_relation,
                        condition,
                    });
                }
                // 内容策略
                let b = this.contentList;
                let multis1 = [];
                for (var i1 = 0; i1 < b.length; i1++) {
                    let contentList1 = [];
                    for (var v1 = 0; v1 < b[i1].contentList1.length; v1++) {
                        // 1
                        let content_select_first = b[i1].contentList1[v1].content_name;
                        //类型
                        let content_select_two = b[i1].contentList1[v1].content_type;
                        // console.log(content_select_first)
                        // console.log(content_select_two)

                        // 邮件正文，附近内容，图片内容
                        if (
                            (content_select_first == "attach_body" ||
                                content_select_first == "ocr_body" ||
                                content_select_first == "body") &&
                            content_select_two == 0
                        ) {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                content_matchcn: b[i1].contentList1[v1].content_matchcn,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (
                            (content_select_first == "attach_body" ||
                                content_select_first == "ocr_body" ||
                                content_select_first == "body") &&
                            content_select_two == 1
                        ) {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (
                            (content_select_first == "peer_ip" ||
                                content_select_first == "env_from" ||
                                content_select_first == "env_rcpt") &&
                            content_select_two == 1
                        ) {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                content_match: b[i1].contentList1[v1].content_match,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (
                            (content_select_first == "peer_ip" ||
                                content_select_first == "env_from" ||
                                content_select_first == "env_rcpt") &&
                            content_select_two == 0
                        ) {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (
                            content_select_first == "header" ||
                            content_select_first == "mime_hdr"
                        ) {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                content_exist: b[i1].contentList1[v1].content_exist,
                                header_key: b[i1].contentList1[v1].header_key,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (content_select_first == "ptr") {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_exist: b[i1].contentList1[v1].content_exist,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (content_select_first == "keyword") {

                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_exist: b[i1].contentList1[v1].content_exist,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                score: b[i1].contentList1[v1].score,
                                range: JSON.stringify(b[i1].contentList1[v1].checkedCities),



                            });
                            if (b[i1].contentList1[v1].checkedCities.length == 0) {
                                this.$message({
                                    type: "warning",
                                    message: `${this.$t("anti_gs1_tan.keyword")}`,
                                });
                                return false;
                            }
                        } else {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,

                                content_relation: b[i1].contentList1[v1].content_relation,
                                content_type: b[i1].contentList1[v1].content_type,

                                regex: b[i1].contentList1[v1].regex,
                                score: b[i1].contentList1[v1].score,
                            });
                        }


                    }
                    multis1.push({
                        content_out_relation: b[i1].content_out_relation,
                        contentList1,
                    });
                }
                // A链接策略
                let c = this.alinkList;
                let multis2 = [];
                for (var i2 = 0; i2 < c.length; i2++) {
                    let alinkList1 = [];
                    for (var v2 = 0; v2 < c[i2].alinkList1.length; v2++) {
                        alinkList1.push({
                            alink_name: c[i2].alinkList1[v2].alink_name,

                            alink_relation: c[i2].alinkList1[v2].alink_relation,
                            alink_type: c[i2].alinkList1[v2].alink_type,

                            regex: c[i2].alinkList1[v2].alink_regex,
                        });
                    }
                    multis2.push({
                        alinkList1,
                    });
                }
                console.log(multis, "保存时候的条件策略");
                console.log(multis1, "保存时候的内容策略");
                console.log(multis2, "保存时候的A链接");
                // console.log(col, "222");

                let filter_name = this.filter_name;
                let filter_describe = this.filter_describe;
                let chkcondition = this.chkcondition;
                let rootcondrelation = this.rootcondrelation;
                let chkcontent = this.chkcontent;
                let rootcontrelation = this.rootcontrelation;
                let chkalink = this.chkalink;
                let alink_out_relation = this.alink_out_relation;
                let shuju = {
                    condition: multis,
                    content: multis1,
                    alink: multis2,
                    filter_name: filter_name,
                    newadd: this.newadd,
                    filter_describe: filter_describe,

                    chkcondition: chkcondition,
                    rootcondrelation: rootcondrelation,
                    chkcontent: chkcontent,
                    rootcontrelation: rootcontrelation,
                    chkalink: chkalink,
                    alink_out_relation: alink_out_relation,
                };
                let col = JSON.stringify(shuju);

                console.log(shuju, "最终");

                let str = this.$qs.stringify({
                    __mode: "save_filter",
                    sid: sid,
                    col: col,
                });
                // console.log(d)

                this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
                    // console.log(res);
                    this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            type: "warning",
                            message: `${res.data.fmstatus.errmsg}`,
                        });

                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
                        });
                        // this.xian2=false
                        console.log(this.filter_name);
                        setTimeout(() => {
                            this.edit2();
                        }, 10);
                    }
                });
            },
            // 过滤编辑保存
            save_filter_strategy() {
                // this.xian2 = false;
                // this.tanchu = false;
                // this.xian1 = true;
                this.$save_hint_test();
                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                let a = this.tiaoa;
                // 条件策略
                let multis = [];
                for (let i = 0; i < a.length; i++) {
                    let condition = [];
                    for (let v = 0; v < a[i].tiaob.length; v++) {
                        let condition_select_first = a[i].tiaob[v].condition_name;
                        console.log(condition_select_first);
                        if (condition_select_first == "network") {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,
                                network_type: a[i].tiaob[v].network_type,
                            });
                        } else if (condition_select_first == "white") {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,
                                white_type: a[i].tiaob[v].white_type,
                            });
                        } else if (condition_select_first == "spfres") {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,
                                spf_condition: a[i].tiaob[v].spf_result,
                            });
                        } else if (
                            condition_select_first == "bodylen" ||
                            condition_select_first == "msgsize" ||
                            condition_select_first == "attsize"
                        ) {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,

                                msgsize_type: a[i].tiaob[v].msgsize_type,
                                msgsize: a[i].tiaob[v].msgsize,
                                msgsize_unit: a[i].tiaob[v].msgsize_unit,
                                // network_type: a[i].tiaob[v].network_type0,
                                // whether: a[i].tiaob[v].whether,
                            });
                        } else if (condition_select_first == "sublen") {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,

                                msgsize_type: a[i].tiaob[v].msgsize_type,
                                msgsize: a[i].tiaob[v].msgsize,
                                msgsize_unit: a[i].tiaob[v].msgsize_unit,
                                // network_type: a[i].tiaob[v].network_type0,
                                // whether: a[i].tiaob[v].whether,
                            });
                        } else if (
                            a == "envtonotlocalnum" ||
                            a == "hdrbsnum" ||
                            a == "hdrnotlocalnum" ||
                            a == "bccnum" ||
                            a == "envbsnum"
                        ) {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,

                                msgsize_type: a[i].tiaob[v].msgsize_type,
                                msgsize: a[i].tiaob[v].msgsize,
                                // msgsize_unit: a[i].tiaob[v].msgsize_unit0,
                            });
                        } else {
                            condition.push({
                                condition_name: a[i].tiaob[v].condition_name,

                                msgsize_type: a[i].tiaob[v].msgsize_type,
                                msgsize: a[i].tiaob[v].msgsize,
                                // msgsize_unit: a[i].tiaob[v].msgsize_unit0,
                            });
                        }
                    }
                    multis.push({
                        // id: a[i].id,
                        condition_relation: a[i].condition_relation,
                        condition,
                    });
                }
                // 内容策略
                let b = this.contentList;
                let multis1 = [];
                for (var i1 = 0; i1 < b.length; i1++) {
                    let contentList1 = [];
                    for (var v1 = 0; v1 < b[i1].contentList1.length; v1++) {
                        // 1
                        let content_select_first = b[i1].contentList1[v1].content_name;
                        //类型
                        let content_select_two = b[i1].contentList1[v1].content_type;
                        // console.log(content_select_first)
                        // console.log(content_select_two)

                        // 邮件正文，附近内容，图片内容
                        if (
                            (content_select_first == "attach_body" ||
                                content_select_first == "ocr_body" ||
                                content_select_first == "body") &&
                            content_select_two == 0
                        ) {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                content_matchcn: b[i1].contentList1[v1].content_matchcn,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (
                            (content_select_first == "attach_body" ||
                                content_select_first == "ocr_body" ||
                                content_select_first == "body") &&
                            content_select_two == 1
                        ) {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (
                            (content_select_first == "peer_ip" ||
                                content_select_first == "env_from" ||
                                content_select_first == "env_rcpt") &&
                            content_select_two == 1
                        ) {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                content_match: b[i1].contentList1[v1].content_match,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (
                            (content_select_first == "peer_ip" ||
                                content_select_first == "env_from" ||
                                content_select_first == "env_rcpt") &&
                            content_select_two == 0
                        ) {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (
                            content_select_first == "header" ||
                            content_select_first == "mime_hdr"
                        ) {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                content_exist: b[i1].contentList1[v1].content_exist,
                                header_key: b[i1].contentList1[v1].header_key,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (content_select_first == "ptr") {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_exist: b[i1].contentList1[v1].content_exist,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                score: b[i1].contentList1[v1].score,
                            });
                        } else if (content_select_first == "keyword") {

                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,
                                content_exist: b[i1].contentList1[v1].content_exist,
                                content_type: b[i1].contentList1[v1].content_type,
                                content_relation: b[i1].contentList1[v1].content_relation,
                                regex: b[i1].contentList1[v1].regex,
                                score: b[i1].contentList1[v1].score,
                                range: JSON.stringify(b[i1].contentList1[v1].checkedCities),



                            });
                            if (b[i1].contentList1[v1].checkedCities.length == 0) {
                                this.$message({
                                    type: "warning",
                                    message: `${this.$t("anti_gs1_tan.keyword")}`,
                                });
                                return false;
                            }
                        } else {
                            contentList1.push({
                                content_name: b[i1].contentList1[v1].content_name,

                                content_relation: b[i1].contentList1[v1].content_relation,
                                content_type: b[i1].contentList1[v1].content_type,

                                regex: b[i1].contentList1[v1].regex,
                                score: b[i1].contentList1[v1].score,
                            });
                        }


                    }
                    multis1.push({
                        content_out_relation: b[i1].content_out_relation,
                        contentList1,
                    });
                }
                // A链接策略
                let c = this.alinkList;
                let multis2 = [];
                for (var i2 = 0; i2 < c.length; i2++) {
                    let alinkList1 = [];
                    for (var v2 = 0; v2 < c[i2].alinkList1.length; v2++) {
                        alinkList1.push({
                            alink_name: c[i2].alinkList1[v2].alink_name,

                            alink_relation: c[i2].alinkList1[v2].alink_relation,
                            alink_type: c[i2].alinkList1[v2].alink_type,

                            regex: c[i2].alinkList1[v2].alink_regex,
                        });
                    }
                    multis2.push({
                        alinkList1,
                    });
                }
                console.log(multis, "保存时候的条件策略");
                console.log(multis1, "保存时候的内容策略");
                console.log(multis2, "保存时候的A链接");
                // console.log(col, "222");

                let filter_name = this.filter_name;
                let filter_describe = this.filter_describe;
                let chkcondition = this.chkcondition;
                let rootcondrelation = this.rootcondrelation;
                let chkcontent = this.chkcontent;
                let rootcontrelation = this.rootcontrelation;
                let chkalink = this.chkalink;
                let alink_out_relation = this.alink_out_relation;
                let shuju = {
                    condition: multis,
                    content: multis1,
                    alink: multis2,
                    filter_name: filter_name,
                    newadd: this.newadd,
                    filter_describe: filter_describe,

                    chkcondition: chkcondition,
                    rootcondrelation: rootcondrelation,
                    chkcontent: chkcontent,
                    rootcontrelation: rootcontrelation,
                    chkalink: chkalink,
                    alink_out_relation: alink_out_relation,
                };
                let col = JSON.stringify(shuju);

                console.log(shuju, "最终");

                let str = this.$qs.stringify({
                    __mode: "save_filter",
                    sid: sid,
                    col: col,
                });
                // console.log(d)

                this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
                    // console.log(res);
                    this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            type: "warning",
                            message: `${res.data.fmstatus.errmsg}`,
                        });

                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
                        });
                        // this.xian2=false
                        console.log(this.filter_name);
                        setTimeout(() => {
                            this.edit2();
                        }, 10);
                    }
                });
            },

            // 过滤器编辑  保存完编辑
            edit2() {
                this.newadd = 0;
                this.xian1 = false;
                this.xian2 = true;
                this.xian3 = 1;
                this.loading = true;
                // console.log(scope);
                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                // console.log(sid);
                let filter_name = this.filter_name;
                console.log(filter_name);
                this.$axios
                    .get("/api/adm/cgi/aspam.cgi", {
                        params: {
                            __mode: "edit_filter",
                            sid: sid,
                            filter_name: filter_name,
                        },
                    })
                    .then((res) => {
                        console.log(res);

                        if (!res.data.fmstatus) {
                            alert(res.data);
                        } else if (res.data.fmstatus.code == "1") {
                            alert(res.data.fmstatus.errmsg);
                            // this.getFileList();
                        } else if (res.data.fmstatus.code == "2") {
                            alert(res.data.fmstatus.errmsg);
                            // this.getFileList();
                        } else if (res.data.fmstatus.code == "3") {
                            alert(res.data.fmstatus.errmsg);
                            this.$router.push({
                                name: "login",
                            });
                        } else {
                            this.loading = false;
                            // this.msgsize_unit=res.data.ret.msgsize_unit
                            this.alink_out_relation = res.data.ret.alinkrelation;

                            this.filter_name = res.data.ret.filter_name;
                            this.filter_describe = res.data.ret.filter_describe;
                            this.rootcondrelation = res.data.ret.rootcondrelation;
                            this.rootcontrelation = res.data.ret.rootcontrelation;
                            // let a = res.data.ret.condition
                            this.chkcontent =
                                res.data.ret.chkcontent == 1 ?
                                (this.chkcontent = true) :
                                (this.chkcontent = false);
                            this.chkcondition =
                                res.data.ret.chkcondition == 1 ?
                                (res.data.ret.chkcondition = true) :
                                false;
                            this.chkalink =
                                res.data.ret.chkalink == 1 ?
                                (res.data.ret.chkalink = true) :
                                false;
                            if (res.data.ret.condition) {
                                this.tiaoa = res.data.ret.condition;
                                console.log(this.tiaoa, "编辑的启用条件策略");
                            } else {
                                this.tiaoa = [{
                                    id: 1,
                                    condition_relation: 1,

                                    tiaob: [{
                                        id: 1,
                                        msgsize_unit: "KB",
                                        options: [{
                                                value: "KB",
                                                label: "KB",
                                            },
                                            {
                                                value: "MB",
                                                label: "MB",
                                            },
                                            {
                                                value: "B",
                                                label: "B",
                                            },
                                        ],
                                        white_type: 0,
                                        white_typee: [{
                                                value: 1,
                                                label: "是",
                                            },
                                            {
                                                value: 0,
                                                label: "否",
                                            },
                                        ],
                                        network_type: "unknown",
                                        network_type00: [],
                                        condition_namee0: [],
                                        condition_name: "msgsize",
                                        msgsize_type: 1,
                                        msgsize_typee0: [],
                                        // sublen_type: 1,
                                        sublen_typee: [],
                                        msgsize0: "",
                                        msgsizee0: "",
                                    }],

                                }, ];
                            }
                            if (res.data.ret.content) {
                                console.log(res.data.ret.content)
                                this.contentList = res.data.ret.content;
                                for (let i = 0; i < this.contentList.length; i++) {

                                    for (let v = 0; v < this.contentList[i].contentList1.length; v++) {

                                        if (this.contentList[i].contentList1[v].checkedCities) {
                                            this.contentList[i].contentList1[v].checkedCities = JSON.parse(this.contentList[i].contentList1[v].checkedCities)
                                        } else {
                                            this.contentList[i].contentList1[v].policy_priv = this.policy_priv
                                            this.contentList[i].contentList1[v].check_show = 1
                                            this.contentList[i].contentList1[v].checkedCities = this.q_dft_keyword
                                            console.log(this.contentList[i].contentList1[v], '这是什么')
                                        }



                                    }

                                }
                                console.log(this.contentList, "编辑的启用内容策略");
                            } else {
                                this.contentList = [{
                                    id: 1,
                                    content_out_relation: 1,

                                    contentList1: [{
                                        id: 1,
                                        score: "",
                                        content_name: this.content_name_default,
                                        content_namee0: [],
                                        content_relation: 1,
                                        content_relation2: 1,
                                        content_relationn0: [],
                                        content_relationn2: [],
                                        content_type: 0,
                                        content_typee0: "",
                                        content_type2: 0,
                                        content_typee2: "",
                                        content_exist: 1,
                                        content_existt: [],
                                        content_matchcn: "",
                                        content_match: 0,
                                        content_matchh: [],
                                        header_key: "",
                                        policy_priv: [],
                                        checkedCities: [],

                                    }, ],
                                }, ];
                            }
                            if (res.data.ret.alink) {
                                this.alinkList = res.data.ret.alink;
                                console.log(this.alinkList, "编辑的启用A链接扫描");
                            } else {
                                this.alinkList = [{
                                    id: 1,

                                    alinkList1: [{
                                        id: 1,

                                        alink_name: "alinktag",
                                        alink_namee0: [],
                                        alink_relation: 1,
                                        alink_relationn0: [],
                                        alink_type: 0,
                                        alink_typee0: "",
                                        alink_regex: "",
                                    }, ],
                                }, ];
                            }
                            this.condition_namee0 = res.data.ret.q_condition_name;
                            this.msgsize_typee0 = res.data.ret.q_condition_equal;
                            this.sublen_typee = res.data.ret.q_condition_equal2;
                            this.content_namee0 = res.data.ret.q_content_name;
                            this.content_relationn0 = res.data.ret.q_content_relation;
                            this.content_relationn2 = res.data.ret.q_content_relation2;
                            this.content_typee0 = res.data.ret.q_content_type;
                            this.content_typee2 = res.data.ret.q_content_type2;
                            this.content_existt = res.data.ret.q_content_exist;
                            this.content_matchh = res.data.ret.q_content_match;
                            this.alink_namee0 = res.data.ret.q_alink_name;
                            this.alink_relationn0 = res.data.ret.q_content_relation;
                            this.alink_typee0 = res.data.ret.q_content_type;
                            this.network_type00 = res.data.ret.q_condition_network;
                            this.white_typee = res.data.ret.q_condition_white;
                        }
                    });
            },
            // 过滤器编辑
            edit1(index, scope) {
                this.newadd = 0;
                this.xian1 = false;
                this.xian2 = true;
                this.xian3 = 1;
                this.loading = true;
                // console.log(scope);
                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                // console.log(sid);
                let filter_name = scope.FILTER_NAME;
                this.$axios
                    .get("/api/adm/cgi/aspam.cgi", {
                        params: {
                            __mode: "edit_filter",
                            sid: sid,
                            filter_name: filter_name,
                        },
                    })
                    .then((res) => {
                        this.loading = false;

                        console.log(res);

                        if (!res.data.fmstatus) {
                            alert(res.data);
                        } else if (res.data.fmstatus.code == "1") {
                            alert(res.data.fmstatus.errmsg);
                            // this.getFileList();
                        } else if (res.data.fmstatus.code == "2") {
                            alert(res.data.fmstatus.errmsg);
                            // this.getFileList();
                        } else if (res.data.fmstatus.code == "3") {
                            alert(res.data.fmstatus.errmsg);
                            this.$router.push({
                                name: "login",
                            });
                        } else {
                            // this.msgsize_unit=res.data.ret.msgsize_unit
                            this.alink_out_relation = res.data.ret.alinkrelation;

                            this.filter_name = res.data.ret.filter_name;
                            this.filter_describe = res.data.ret.filter_describe;
                            this.rootcondrelation = res.data.ret.rootcondrelation;
                            this.rootcontrelation = res.data.ret.rootcontrelation;
                            // let a = res.data.ret.condition
                            this.chkcontent =
                                res.data.ret.chkcontent == 1 ?
                                (this.chkcontent = true) :
                                (this.chkcontent = false);
                            this.chkcondition =
                                res.data.ret.chkcondition == 1 ?
                                (res.data.ret.chkcondition = true) :
                                false;
                            this.chkalink =
                                res.data.ret.chkalink == 1 ?
                                (res.data.ret.chkalink = true) :
                                false;
                            if (res.data.ret.condition) {
                                this.tiaoa = res.data.ret.condition;
                                console.log(this.tiaoa, "编辑的启用条件策略");
                            } else {
                                this.tiaoa = [{
                                    id: 1,
                                    condition_relation: 1,

                                    tiaob: [{
                                        id: 1,
                                        msgsize_unit: "KB",
                                        options: [{
                                                value: "KB",
                                                label: "KB",
                                            },
                                            {
                                                value: "MB",
                                                label: "MB",
                                            },
                                            {
                                                value: "B",
                                                label: "B",
                                            },
                                        ],
                                        white_type: 0,
                                        white_typee: [{
                                                value: 1,
                                                label: "是",
                                            },
                                            {
                                                value: 0,
                                                label: "否",
                                            },
                                        ],
                                        network_type: "unknown",
                                        network_type00: [],
                                        condition_namee0: [],
                                        condition_name: "msgsize",
                                        msgsize_type: 1,
                                        msgsize_typee0: [],
                                        // sublen_type: 1,
                                        sublen_typee: [],
                                        msgsize0: "",
                                        msgsizee0: "",
                                    }, ],
                                }, ];
                            }
                            if (res.data.ret.content) {
                                this.contentList = res.data.ret.content;

                                for (let i = 0; i < this.contentList.length; i++) {

                                    for (let v = 0; v < this.contentList[i].contentList1.length; v++) {
                                        //   let condition_select_first = a[i].tiaob[v].condition_name;
                                        console.log(this.contentList[i].contentList1[v])
                                        if (this.contentList[i].contentList1[v].checkedCities) {
                                            this.contentList[i].contentList1[v].checkedCities = JSON.parse(this.contentList[i].contentList1[v].checkedCities)
                                        } else {
                                            this.contentList[i].contentList1[v].policy_priv = this.q_dft_keyword

                                            this.contentList[i].contentList1[v].checkedCities = this.q_dft_keyword

                                            this.contentList[i].contentList1[v].check_show = 1

                                        }



                                    }

                                }
                            } else {
                                this.contentList = [{
                                    id: 1,
                                    content_out_relation: 1,

                                    contentList1: [{
                                        id: 1,
                                        score: "",
                                        content_name: this.content_name_default,
                                        content_namee0: [],
                                        content_relation: 1,
                                        content_relation2: 1,
                                        content_relationn0: [],
                                        content_relationn2: [],
                                        content_type: 0,
                                        content_typee0: "",
                                        content_type2: 0,
                                        content_typee2: "",
                                        content_exist: 1,
                                        content_existt: [],
                                        content_matchcn: "",
                                        content_match: 0,
                                        content_matchh: [],
                                        header_key: "",
                                        policy_priv: [],
                                        checkedCities: this.q_dft_keyword,

                                    }, ],
                                }, ];
                            }
                            if (res.data.ret.alink) {
                                this.alinkList = res.data.ret.alink;
                                console.log(this.alinkList, "编辑的启用A链接扫描", );
                            } else {
                                this.alinkList = [{
                                    id: 1,

                                    alinkList1: [{
                                        id: 1,

                                        alink_name: "alinktag",
                                        alink_namee0: [],
                                        alink_relation: 1,
                                        alink_relationn0: [],
                                        alink_type: 0,
                                        alink_typee0: "",
                                        alink_regex: "",
                                    }, ],
                                }, ];
                            }
                            this.condition_namee0 = res.data.ret.q_condition_name;
                            this.msgsize_typee0 = res.data.ret.q_condition_equal;
                            this.sublen_typee = res.data.ret.q_condition_equal2;
                            this.content_namee0 = res.data.ret.q_content_name;
                            this.content_relationn0 = res.data.ret.q_content_relation;
                            this.content_relationn2 = res.data.ret.q_content_relation2;
                            this.content_typee0 = res.data.ret.q_content_type;
                            this.content_typee2 = res.data.ret.q_content_type2;
                            this.content_existt = res.data.ret.q_content_exist;
                            this.content_matchh = res.data.ret.q_content_match;
                            this.alink_namee0 = res.data.ret.q_alink_name;
                            this.alink_relationn0 = res.data.ret.q_content_relation;
                            this.alink_typee0 = res.data.ret.q_content_type;
                            this.network_type00 = res.data.ret.q_condition_network;
                            this.white_typee = res.data.ret.q_condition_white;
                        }
                    });
            },
            // 显示
            tan_add_filter: function() {
                // this.tanchu = true;
                this.newadd = 1;
                this.xian1 = false;
                this.xian2 = true;
                this.xian3 = 0;

                this.filter_name = "";
                this.filter_describe = "";
                (this.tiaoa = [{
                    id: 1,
                    condition_relation: 1,

                    tiaob: [{
                        id: 1,
                        msgsize_unit: "KB",
                        options: [{
                                value: "KB",
                                label: "KB",
                            },
                            {
                                value: "MB",
                                label: "MB",
                            },
                            {
                                value: "B",
                                label: "B",
                            },
                        ],
                        white_type: 0,
                        white_typee: [{
                                value: "1",
                                label: "是",
                            },
                            {
                                value: "0",
                                label: "否",
                            },
                        ],
                        network_type: "unknown",
                        network_type00: [],
                        condition_namee0: [],
                        condition_name: "msgsize",
                        msgsize_type: 1,
                        msgsize_typee0: [],
                        msgsize: "",
                        msgsizee0: "",
                    }, ],
                }, ]),
                // console.log(this.tiaoa)
                (this.contentList = [{
                    id: 1,
                    content_out_relation: 1,

                    contentList1: [{
                        id: 1,
                        score: "",
                        content_name: this.content_name_default,
                        content_namee0: [],
                        content_relation: 1,
                        content_relation2: 1,
                        content_relationn0: [],
                        content_relationn2: [],
                        content_type: 1,
                        content_type2: 0,
                        content_typee0: "",
                        content_typee2: "",
                        content_exist: 1,
                        content_existt: [],
                        content_matchcn: "",
                        content_match: 1,
                        content_matchh: [],
                        header_key: "",
                        policy_priv: [],
                        checkedCities: this.q_dft_keyword,
                    }, ],
                }, ]),
                (this.alinkList = [{
                    id: 1,

                    alinkList1: [{
                        id: 1,

                        alink_name: "alinktag",
                        alink_namee0: [],
                        alink_relation: 1,
                        alink_relationn0: [],
                        alink_type: 0,
                        alink_typee0: "",
                        alink_regex: "",
                    }, ],
                }, ]);
            },
            // 打开关闭
            cancel: function() {
                this.xian2 = false;
                this.tanchu = false;
                this.xian1 = true;
                this.chkcondition = false;
                this.chkcontent = true;
                this.chkalink = false;
                this.rootcontrelation = 1;
                this.rootcondrelation = 1;
                this.alink_out_relation = 1;

                this.getFileList();
            },

            cancel2() {
                this.xian3 = 0;
                this.xian2 = false;
                this.tanchu = false;
                this.xian1 = true;
                this.chkcondition = false;
                this.chkcontent = true;
                this.chkalink = false;
                this.rootcontrelation = 1;
                this.rootcondrelation = 1;
                this.alink_out_relation = 1;
                (this.tiaoa = [{
                    id: 1,
                    condition_relation: 1,

                    tiaob: [{
                        id: 1,
                        msgsize_unit0: "KB",
                        options: [{
                                value: "KB",
                                label: "KB",
                            },
                            {
                                value: "MB",
                                label: "MB",
                            },
                            {
                                value: "B",
                                label: "B",
                            },
                        ],
                        white_type: "0",
                        white_typee: [{
                                value: "1",
                                label: "是",
                            },
                            {
                                value: "0",
                                label: "否",
                            },
                        ],
                        network_type: "unknown",
                        network_type00: [],
                        condition_namee0: [],
                        condition_name: "msgsize",
                        msgsize_type: 1,
                        msgsize_typee0: [],
                        msgsize: "",
                        msgsizee0: "",
                    }, ],
                }, ]),
                // console.log(this.tiaoa)
                (this.contentList = [{
                    id: 1,
                    content_out_relation: 1,

                    contentList1: [{
                        id: 1,
                        score: "",
                        content_name: this.content_name_default,
                        content_namee0: [],
                        content_relation: 1,
                        content_relationn0: [],
                        content_type: 0,
                        content_typee0: "",
                        content_exist: 1,
                        content_existt: [],
                        content_matchcn: "",
                        content_match: 0,
                        content_matchh: [],
                        header_key: "",
                    }, ],
                }, ]),
                (this.alinkList = [{
                    id: 1,

                    alinkList1: [{
                        id: 1,

                        alink_name: "alinktag",
                        alink_namee0: [],
                        alink_relation: 1,
                        alink_relationn0: [],
                        alink_type: 0,
                        alink_typee0: "",
                        alink_regex: "",
                    }, ],
                }, ]),
                this.getFileList();
            },
            tanOff: function() {
                this.xian2 = false;
                this.tanchu = false;
                this.xian1 = true;
            },
        },

    }
    // 用户自定义隔离列表 和 elk非正常邮件


export const list_policy_details = {
    data() {
        return {
            perform_load: 0,
            q_page_size: [],
            has_rectime: '',
            is_area: '',
            user_rec: 0,
            detail_info: '',
            detail_info_show: 0,
            ping_an_show: 0,
            data_bulkpass_show: "",
            data_forword: '',
            data_forword_address: '',
            data_can_delete_show: "",
            attsize_unit: [],
            subwhy: "",
            fileList: [],
            fujian: [],
            fujian1: [],
            html: "",
            html1: "",
            loading: false,
            // 原因分析
            reason1: "",
            reason2: false,
            // 显示摘要
            abstract1: "",
            abstract2: false,
            // 正文分析
            matter1: "",
            matter2: false,
            search_time: 0,
            // 原始正文
            original1: "",
            original2: false,
            delect_show: "",
            print_show: "",
            original_show: "",
            abstract_show: "",
            trainspam_show: "",
            readmsg_show: "",
            result_return_show: 0,
            // 分词信息
            print1: "",
            print2: false,
            // 附件名
            fname: "",
            // 附件个数
            fnameage: 0,
            // 判断加入还是移出黑名单
            pan1: true,
            // 自适应高度
            // clientHeight: 480,
            // clientHeight: document.documentElement.clientHeight - 200 + 'px' || '',
            list_first: 1,
            list_two: 0,
            details: {},
            // 只可以选择今天之前的日期
            pickerOptions: {
                disabledDate(time) {
                    var todayYear = new Date().getFullYear();
                    var todayMonth = new Date().getMonth();
                    var todayDay = new Date().getDate();
                    var todayTime = new Date(
                        todayYear,
                        todayMonth,
                        todayDay,
                        "23",
                        "59",
                        "59"
                    ).getTime(); // 毫秒

                    return time.getTime() > todayTime;
                },
            },
            restaurants: [],
            q_order_type_arr: [],
            q_order_sort_arr: [],
            // 查找
            // 查询条件
            userrule: '',
            col: {
                user_rec: 0,
                q_order_type: "datetime",
                q_order_sort: "desc",
                linkunit: "1",
                bccunit: "1",
                achunit: "1",
                select: "",
                istls: "",
                isl: "",
                nblink: "",
                nbbcc: "",
                nbattach: "",
                isout: "",
                envfrom: "",
                envrcpt: "",
                ip: "",
                attach: "",
                hdrfrom: "",
                hdrto: "",
                url: "",
                mid: "",
                subject: "",
                body: "",
                minion_host: "",
                startdate: "",
                type: 0,
                spam_reason: "",
                haspass: 0,
                min_size: "",
                max_size: "",
                min_size_unit: "MB",
                max_size_unit: "MB",
                min_attsize: "",
                max_attsize: "",
                min_attsize_unit: "MB",
                max_attsize_unit: "MB",
                subwhy: "",
                // 自定义隔离列表
                userrule: '',
            },
            startdate: "",

            // 总数
            totalnums: 0,
            size: 0,
            // 每页条数
            pagesize: 0,
            //   默认前往第几页
            page: 0,
            xian6: true,
            xian: false,
            btnText: "展示更多",
            multipleSelection: [],
            selectList: [], // 选中的数据
            excelData: [],
            allSelect: false,
            isIndeterminate: true,

            form: {
                username: "",
            },
            // 集群节点
            minionhost: [],

            // 拦截原因
            spamreason: "",
            // 类型
            type1: [],
            // 是否放行
            haspass1: [],

            size_unit: [{
                    value: "MB",
                    label: "MB",
                },
                {
                    value: "KB",
                    label: "KB",
                },
                {
                    value: "B",
                    label: "B",
                },
            ],
            default_sort: {},
            value: "",
            value1: [new Date(2020, 5, 10, 10, 10), new Date(2020, 6, 11, 10, 10)],
            fileList1: [],

            // 查看
            col1: [],
            // 搜索默认
            col2: {
                user_rec: 0,
                linkunit: "",
                bccunit: "",
                achunit: "",
                istls: "",
                isl: "",
                nblink: "",
                nbbcc: "",
                nbattach: "",
                isout: "",
                envfrom: "",
                envrcpt: "",
                ip: "",
                attach: "",
                hdrfrom: "",
                hdrto: "",
                url: "",
                mid: "",
                subject: "",
                body: "",
                minion_host: "",
                startdate: "",
                type: "",
                spam_reason: "",
                haspass: "",
                min_size: "",
                max_size: "",
                min_size_unit: "",
                max_size_unit: "",
                min_attsize: "",
                max_attsize: "",
                min_attsize_unit: "MB",
                max_attsize_unit: "MB",
                subwhy: "",
                q_order_type: "datetime",
                q_order_sort: "dese",
            },
            geng: true,
            geng1: false,
            date_type: "",
            col_search: "",
            has_pass_style: "",
            loading_time: 0,
            page_num: "",
            isout_arr: [],
            istls_arr: [],
            list_custom_one: 1,
            list_custom_two: 0,
            fileListnum: [],

            num_load: 0,
        };
    },

    created() {



    },

    mounted() {

    },

    methods: {

        // 判断状态变色
        tableCellClassName({
            row
        }) {
            // console.log(row, rowIndex);

            if (row.HASPASS == 1) {
                return "sent1";
            } else if (row.HASPASS == 0) {
                return "sent2";
            }
            return "";
        },

        spam_reason_change(val) {
            console.log(val);
            if (val == "combrule" || val == "newrule") {
                this.subwhy = 1;
            } else {
                this.subwhy = 0;
            }
        },
        // 附件下载下载
        down(a) {
            // console.log(this.details);
            if (this.authority_to_judge.download_attach == 1 && this.$root.jurisdiction.only_query != 0) {
                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                // console.log(sid);

                let __mode = "download";
                console.log(__mode);

                let rec_id = this.details.rec_id;
                console.log(rec_id);

                let index = this.details.index;
                console.log(index);

                let msgtype = this.details.msgtype;
                console.log(msgtype);
                let cnt = cnt;

                console.log(a);

                window.open(
                    `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}&mimeid=${a}`
                );
            } else {
                this.$message({

                    message: `${this.$t("tan.not_pre")}`,
                    type: "error",
                });
            }
        },
        // 自定义列表附件下载
        down_pric(a) {
            if (this.priv_json.download_attach && this.$root.jurisdiction.only_query != 0) {
                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                // console.log(sid);

                let __mode = "download";
                console.log(__mode);

                let rec_id = this.details.rec_id;
                console.log(rec_id);

                let index = this.details.index;
                console.log(index);

                let msgtype = this.details.msgtype;
                console.log(msgtype);
                let cnt = cnt;

                console.log(a);

                window.open(
                    `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}&mimeid=${a}`
                );
            } else {
                this.$message({

                    message: `${this.$t("tan.not_pre")}`,
                    type: "error",
                });
            }

        },
        // 放行
        pass() {
            this.$confirm("将放行此邮件，你确定不是垃圾邮件吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.pass1();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消放行",
                    });
                });
        },
        // 放行条件
        pass1() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            let col1 = this.col_search;
            console.log(this.col_search, "这是什么");
            this.$axios
                .get("/api/adm/cgi/elkspam.cgi", {
                    params: {
                        __mode: "pass_elkspam",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 1,
                        msgtype: msgtype,
                        col: col1,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.$message({
                            type: "success",
                            message: "放行成功!",
                        });
                        console.log(res);
                        this.back();
                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 信头
        header() {
            // console.log(this.details);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "readmsg_header";
            // console.log(__mode);

            let rec_id = this.details.rec_id;
            // console.log(rec_id);

            let index = this.details.index;
            // console.log(index);

            let msgtype = this.details.msgtype;
            // console.log(msgtype);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}`
            );
        },
        // 原始邮件
        dawdata() {
            // console.log(this.details);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let __mode = "readmsg_rawdt";
            // console.log(__mode);

            let rec_id = this.details.rec_id;
            // console.log(rec_id);

            let index = this.details.index;
            // console.log(index);

            let msgtype = this.details.msgtype;
            // console.log(msgtype);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}`
            );
        },

        // 分词信息
        print() {
            this.print_show_two_elk();
        },
        // 原始正文
        original() {
            this.originol_show_to_elk();
        },
        // 正文分析
        matter() {
            this.matter_show_two_elk();
        },
        // 显示摘要
        abstract() {
            this.abstract_show_tow_elk();
        },
        // 原因分析abstract
        reason() {
            this.reason_show_to_elk();
        },


        yin4() {
            this.print2 = false;
            // this.abstract2 = false;
        },
        yin3() {
            this.original2 = false;
            // this.abstract2 = false;
        },
        yin2() {
            this.matter2 = false;
            // this.abstract2 = false;
        },
        yin() {
            this.reason2 = false;
            // this.abstract2 = false;
        },
        yin1() {
            // this.reason2 = false;
            this.abstract2 = false;
        },
        // 下载
        xiazai() {
            // console.log(this.details);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let __mode = "download_eml";
            console.log(__mode);

            let rec_id = this.details.rec_id;
            console.log(rec_id);

            let index = this.details.index;
            console.log(index);

            let msgtype = this.details.msgtype;
            console.log(msgtype);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}`
            );
        },

        // },
        get_top() {
            console.log("是否滚动对应元素", this.details.rec_id);
            this.loading = false;

            for (let v = 0; v < this.fileList1.length; v++) {
                if (this.details.rec_id == this.fileList1[v].REC_ID) {
                    console.log(v)
                    this.$refs.multipleTable.setCurrentRow(this.fileList1[v]);
                    document
                        .getElementById(`${this.details.rec_id}`)
                        .scrollIntoView({ block: "center" });
                }
            }








        },
        // 返回
        back() {
            // console.log(this.col,'this.col',this.col_search,'查询')
            this.col_search.totalnums = "";
            this.loading_time = 4;
            this.html = "";
            this.getFileList_2();
            this.list_first = 1;
            this.list_two = 0;

            //
        },
        // 数据

        getFileList() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this.details);
            // 获取表单数据,搜索条件
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            let col1 = this.col_search;
            console.log(col1, "点击每行，传的col");
            // let  recid=this.details
            // console.log(rec_id);
            // console.log(msgtype);
            //
            // console.log(this.details);
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "readmsg_sum",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 1,
                        msgtype: msgtype,
                        CONDITION_COL: col1,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log( document.getElementById('main_btn')[0].offsetHeight )
                    // console.log(res.data.fmstatus.code);
                    if (!res) {
                        this.loading = false;
                    } else if (!res.data.fmstatus) {
                        alert(res.data);
                        this.loading = false;
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.list_first = 1;
                        // this.list_two = 0;
                        this.loading = false;
                    } else if (res.data.fmstatus.code == "2") {
                        //  alert(55555)
                        alert(res.data.fmstatus.errmsg);
                        // this.list_first = 1;
                        // this.list_two = 0;
                        this.loading = false;
                    } else {

                        this.restore_defaults();
                        if (res.data.ret.DETAIL_INFO) {
                            this.detail_info = res.data.ret.DETAIL_INFO;
                            this.detail_info_show = 1;

                        } else {
                            this.detail_info_show = 0;

                        }
                        document.getElementById("detail_type").scrollIntoView(true);
                        setTimeout(function() {
                            let top_style = document.getElementById("main_btn").offsetHeight;
                            this.top_style_height = top_style;
                            console.log(this.top_style_height);
                            document.getElementById("main_btn1").style.marginTop =
                                this.top_style_height + "px";
                        }, 300);
                        this.list_first = 0;
                        this.list_two = 1;

                        //  显示摘要，正文分析
                        this.abstract_show = res.data.ret.SYS_SHOW_DIGEST;
                        //  原始正文
                        this.original_show = res.data.ret.SYS_SHOW_ORIGINAL_BODY;
                        //分词信息
                        this.print_show = res.data.ret.SYS_SHOW_PAETICIPLE_INFO;
                        // 垃圾训练，正常训练
                        this.trainspam_show = res.data.ret.SYS_SELF_BUILD_BAYES_ON;
                        // 删除
                        this.delect_show = res.data.ret.SYS_GATE_SPAM_CAN_DELETE;
                        // 上报正常

                        this.fileList = res.data.ret;






                        this.fujian = res.data.ret.datalist;
                        this.has_pass_style = res.data.ret.HASPASS;
                        // this.fnameage=this.fujian.length
                        if (res.data.ret.datalist) {
                            let a = 0;
                            for (let i = 0; i <= this.fujian.length; i++) {
                                a = i;
                            }
                            this.fnameage = a;
                            this.fname = res.data.ret.datalist[0].NAME;
                        }
                        // console.log(this.fujian.length)
                        // console.log(a)

                        // console.log(this.fname);
                        this.html = res.data.ret.BODY;
                        // this.fileList.BODY.replace("display: block !important",'')
                        // console.log(   this.fileList.BODY)
                        // console.log(document.getElementById('cent2')),
                        this.html1 = res.data.ret.SUBJECT;
                        this.loading = false;


                    }
                });
        },
        // email移出黑名单
        tan11() {
            this.$confirm(`${this.$t("tan.tan11")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_blsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        },

        del_email_white() {
            this.$confirm(`${this.$t("tan.tan12")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let email_name = JSON.parse(sessionStorage.getItem("usermsg")) ?
                        JSON.parse(sessionStorage.getItem("usermsg")).USERNAME :
                        "";
                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_newuser_email_wlsender",
                                dnoremail: dnoremail,
                                email_name: email_name,
                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        },
        //  email移出白名单
        tan12() {
            this.$confirm(`${this.$t("tan.tan12")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_wlsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        },
        //  ip移出黑名单
        tan13() {
            this.$confirm(`${this.$t("tan.tan13")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_ipbl",
                                blip: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        }, //  ip移出白名单
        tan14() {
            this.$confirm(`${this.$t("tan.tan14")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_ipwl",
                                wlip: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        },
        // 弹框
        tan1() {
            // var b
            this.$confirm(`${this.$t("tan.tan1")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_blsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },

        add_emali_white() {
            this.$confirm(`${this.$t("tan.tan2")}`, "提示", {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);
                    let email_name = JSON.parse(sessionStorage.getItem("usermsg")) ?
                        JSON.parse(sessionStorage.getItem("usermsg")).USERNAME :
                        "";
                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_email_wlsender",
                                dnoremail: dnoremail,
                                email_name: email_name,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },
        // 弹框
        tan2() {
            this.$confirm(`${this.$t("tan.tan2")}`, "提示", {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_wlsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },

        // 弹框
        tan3() {
            // var b

            this.$confirm(`${this.$t("tan.tan3")}`, "提示", {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;
                    // console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_ipbl",
                                ipaddr: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },
        // 弹框
        tan4() {
            // var b

            this.$confirm(`${this.$t("tan.tan4")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;
                    // console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_ipwl",
                                ipaddr: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },
        chuli(row, column, cellValue, index) {
            console.log(1);
            console.log(row, column, cellValue, index);
        },
        // 上报垃圾
        report_msg() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let rec_id = this.details.rec_id;
            let msgtype = this.details.msgtype;
            let index = this.details.index;

            let str = this.$qs.stringify({
                __mode: "report_msg",
                sid: sid,
                rec_id: rec_id,
                as_spam: 2,
                msgtype: msgtype,
                is_elk: 1,
                index: index,
            });
            console.log(str);
            this.$axios.post("/api/adm/cgi/readmsg.cgi", str).then((res) => {
                console.log(res);

                if (!res.data.fmstatus) {
                    alert(res.data);
                } else if (res.data.fmstatus.code == "1") {
                    alert(res.data.fmstatus.errmsg);
                } else if (res.data.fmstatus.code == "2") {
                    alert(res.data.fmstatus.errmsg);
                    //   this.getFileList();
                } else if (res.data.fmstatus.code == "3") {
                    // alert(res.data.fmstatus.errmsg);
                    this.$router.push({
                        name: "login",
                    });
                } else {
                    this.$message({
                        type: "success",
                        message: `${this.$t("anti_gs1_tan.save_sueecss3")}`,
                    });
                }
            });
        },
        data_delete_img() {
            if (this.$root.jurisdiction.only_query != 0) {
                this.data_delete()
            } else {
                this.$message({

                    message: `${this.$t("tan.not_pre")}`,
                    type: "error",
                });
            }
        },
        bulkpass_img() {
            if (this.$root.jurisdiction.only_query != 0) {
                this.bulkpass()
            } else {
                this.$message({

                    message: `${this.$t("tan.not_pre")}`,
                    type: "error",
                });
            }
        },
        data_delete_area() {
            this.is_area = 1;
            this.data_delete()
        },
        // 全部下删除
        data_delete() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请至少勾选一项，再进行操作",
                    type: "warning",
                });
                return;
            } else {
                this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
                        confirmButtonText: `${this.$t("tan.confirm")}`,
                        cancelButtonText: `${this.$t("tan.cancel")}`,
                        type: "warning",
                    })
                    .then(() => {
                        this.loading = true;

                        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                        console.log(sid);
                        // console.log(this)
                        // 获取表单数据,搜索条件
                        let col = (this.col = this.col_search);
                        col.totalnums = "";
                        console.log(col, "传的什么啊");
                        var arr = this.multipleSelection;
                        // console.log(arr, "全选后，获取的数组");
                        let multis = [];
                        for (var i = 0; i < arr.length; i++) {
                            multis.push(arr[i].SEL_ID);
                        }
                        // console.log(multis, "选中后的批量放行id");
                        let multis1 = JSON.stringify(multis);
                        let str = this.$qs.stringify({
                            __mode: "elk_spam_delete",
                            sid: sid,
                            col: col,
                            msg_json: multis1,
                            is_area: this.is_area,
                            area: this.userrule,
                        });
                        this.$axios
                            .post("/api/adm/cgi/elkspam.cgi", str)
                            .then((res) => {
                                console.log(res);
                                if (!res) {
                                    this.loading = false;
                                } else if (!res.data.fmstatus) {
                                    alert(res.data);
                                } else if (res.data.fmstatus.code == "2") {
                                    alert(res.data.fmstatus.errmsg);
                                    this.loading = false;
                                } else if (res.data.fmstatus.code == "3") {
                                    alert(res.data.fmstatus.errmsg);
                                    this.$router.push({
                                        name: "login",
                                    });
                                } else {
                                    this.loading = false;
                                    this.$message({
                                        type: "success",
                                        message: `${this.$t("anti_gs1_tan.del1")}`,
                                    });
                                    this.clearSelect()
                                    this.getFileList_1();
                                }
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: `${this.$t("anti_gs1_tan.del2")}`,
                        });
                    });
            }

        },
        readmsg_sum_area() {
            this.is_area = 1;
            this.readmsg_sum()
        },
        // 删除当前邮件
        readmsg_sum() {
            let page_num = Math.floor((this.totalnums + this.size - 1) / this.size);
            this.page_num = page_num;
            console.log(this.details, "details", this.details.INDEX_ID - 1);
            this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let rec_id = this.details.rec_id;
                    let msgtype = this.details.msgtype;
                    let index = this.details.index;

                    let str = this.$qs.stringify({
                        __mode: "readmsg_sum",
                        sid: sid,
                        rec_id: rec_id,
                        is_next: 3,
                        msgtype: msgtype,
                        index: index,
                        is_elk: 1,
                        is_area: this.is_area
                    });
                    this.$axios.post("/api/adm/cgi/readmsg.cgi", str).then((res) => {
                        console.log(res);

                        if (!res.data.fmstatus) {
                            alert(res.data);
                        } else if (res.data.fmstatus.code == "1") {
                            alert(res.data.fmstatus.errmsg);
                        } else if (res.data.fmstatus.code == "2") {
                            alert(res.data.fmstatus.errmsg);
                            //   this.getFileList();
                        } else if (res.data.fmstatus.code == "3") {
                            // alert(res.data.fmstatus.errmsg);
                            this.$router.push({
                                name: "login",
                            });
                        } else {
                            let delect_hin = 0;

                            if (delect_hin == 0) {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("anti_gs1_tan.del1")}`,
                                });
                            }
                            console.log(this.details.INDEX_ID);
                            this.fileList1.splice(this.details.INDEX_ID, 1);
                            console.log(this.fileList1, "删除后的数据");
                            for (let i = 0; i < this.fileList1.length; i++) {
                                this.fileList1[i].INDEX_ID = i;
                                // console.log( this.fileList1[i].INDEX_ID)
                            }

                            if (
                                // 当前页  第一封  当前页  数组长度为0，page 不是第一页
                                this.details.INDEX_ID == 0 &&
                                this.fileList1.length == 0 &&
                                this.page < page_num
                            ) {
                                // this.col_search.page = this.col.page - 1;
                                this.col_search.totalnums = "";
                                this.loading_time = 5;
                                // alert("下一页的数据 ,id=0", this.page, this.details.INDEX_ID);
                                console.log(this.page, "this.page_num", this.page_num);
                                this.getFileList_2();
                            } else if (
                                // 当前页 最后一封   id =  长度 ，有下一页
                                this.details.INDEX_ID == this.fileList1.length &&
                                this.page < page_num
                            ) {
                                this.col_search.totalnums = "";

                                console.log(this.page, "this.page_num", this.page_num);
                                // alert("下一页的数据", this.page, this.details.INDEX_ID);

                                this.loading_time = 5;

                                this.getFileList_2();
                            } else if (
                                // 当前页  第一封               当前页  数组长度为0，说明没有数据
                                this.details.INDEX_ID == 0 &&
                                this.fileList1.length == 0 &&
                                this.page == 1
                            ) {
                                delect_hin = 1;
                                this.back();

                                if (delect_hin == 1) {
                                    this.$message({
                                        type: "success",
                                        message: `${this.$t("anti_gs1_tan.del4")}`,
                                    });
                                }
                            } else if (
                                // 当前页  第一封   当前页  数组长度为0，说明没有数据  还有页数
                                this.details.INDEX_ID == 0 &&
                                this.fileList1.length == 0 &&
                                this.page == page_num
                            ) {
                                this.col_search.page = this.col_search.page - 1;
                                this.col_search.totalnums = "";
                                // alert("到上一页最后一封", this.page, this.details.INDEX_ID);

                                this.loading_time = 1;
                                //加载下一页的数据

                                this.getFileList_2();
                                console.log(this.page, "this.page_num", this.page_num);
                            } else if (
                                // 当前页  最后一封  id =  长度  如果 在最后一页，，
                                this.details.INDEX_ID == this.fileList1.length &&
                                this.page == page_num
                            ) {
                                // alert("最后一页，的上一条");
                                this.loading_time = 1;
                                //加载下一页的数据

                                this.getFileList_2();
                                console.log(this.page, "this.page_num", this.page_num);
                            } else {
                                // alert("下一封", this.page);
                                console.log(
                                    this.page,
                                    "this.page_num",
                                    this.page_num,
                                    this.details.INDEX_ID
                                );
                                this.next_email_del();
                            }
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("anti_gs1_tan.del2")}`,
                    });
                });
        },
        // 下一封

        next_email() {
            this.loading_time = 2;
            let page_num = Math.floor((this.totalnums + this.size - 1) / this.size);
            this.page_num = page_num;
            if (
                this.details.INDEX_ID == this.fileList1.length - 1 &&
                this.page == page_num
            ) {
                this.$message({
                    type: "success",
                    message: `${this.$t("logs.next_mail")}`,
                });
            } else {
                if (
                    this.details.INDEX_ID == this.fileList1.length - 1 &&
                    this.page < page_num
                ) {
                    this.loading = true;
                    this.col = this.col_search;
                    this.col.page = this.col.page + 1;

                    this.getFileList_2(); //加载下一页的数据
                    //   setTimeout(() => {
                    //     this.load_next_time(), console.log(99);
                    //   }, 3000);
                } else {
                    console.log(this.fileList1[this.details.INDEX_ID]);
                    let row = this.fileList1[this.details.INDEX_ID + 1];
                    console.log(row, "这是第几风");
                    console.log(this.page, "第xxx  页");
                    this.details.rec_id = row.REC_ID;
                    this.details.index = row.INDEX;
                    this.details.msgtype = row.MSGTYPE;
                    this.details.INDEX_ID = row.INDEX_ID;
                    this.getFileList();
                }
            }
        },

        // 上一封
        up_email() {
            this.loading_time = 1;
            //   console.log(this.details. INDEX_ID);
            if (this.details.INDEX_ID == 0 && this.page == 1) {
                console.log(this.page, "第一页，");
                this.$message({
                    type: "success",
                    message: `${this.$t("logs.up_mail")}`,
                });
            } else {
                if (this.details.INDEX_ID == 0 && this.page > 1) {
                    this.loading = true;
                    this.col = this.col_search;
                    this.col.page = this.col.page - 1;

                    this.getFileList_2(); //加载上一页的数据
                    //   setTimeout(() => {
                    //     this.load_up_time(), console.log(99);
                    //   }, 3000);
                } else {
                    console.log(this.page, "第xxx  页");

                    // console.log(this.fileList1, "有诶有数据呢");
                    console.log(this.details, "details", this.details.INDEX_ID - 1);
                    let row = this.fileList1[this.details.INDEX_ID - 1];
                    console.log(row, "这是第几封");

                    this.details.rec_id = row.REC_ID;
                    this.details.index = row.INDEX;
                    this.details.msgtype = row.MSGTYPE;
                    this.details.INDEX_ID = row.INDEX_ID;
                    this.getFileList();
                }
            }
        },
        // 下一页第一封
        load_next_time() {
            let row = this.fileList1[0];

            console.log(row, "这是第当前页最后一封吗");
            this.details.rec_id = row.REC_ID;
            this.details.index = row.INDEX;
            this.details.msgtype = row.MSGTYPE;
            this.details.INDEX_ID = row.INDEX_ID;
            // this.getFileList();
            setTimeout(() => {
                this.getFileList(), console.log(99);
            }, 100);
        },
        // 删除后的翻页，index id  应该是和翻页前相同
        load_up_time_next() {
            let row = this.fileList1[this.details.INDEX_ID];

            console.log(row, "这是第当前页最后一封吗");
            this.details.rec_id = row.REC_ID;
            this.details.index = row.INDEX;
            this.details.msgtype = row.MSGTYPE;
            this.details.INDEX_ID = row.INDEX_ID;
            // this.getFileList();
            setTimeout(() => {
                this.getFileList(), console.log(99);
            }, 100);
        },
        //删除后的下一封
        next_email_del() {
            let row = this.fileList1[this.details.INDEX_ID];
            console.log(row, "这是第几风");
            console.log(this.page, "第xxx  页");
            this.details.rec_id = row.REC_ID;
            this.details.index = row.INDEX;
            this.details.msgtype = row.MSGTYPE;
            this.details.INDEX_ID = row.INDEX_ID;
            this.getFileList();
        },
        // 上一页最后一封
        load_up_time() {
            let row = this.fileList1[this.fileList1.length - 1];

            console.log(row, "这是第当前页最后一封吗");
            this.details.rec_id = row.REC_ID;
            this.details.index = row.INDEX;
            this.details.msgtype = row.MSGTYPE;
            this.details.INDEX_ID = row.INDEX_ID;
            // this.getFileList();
            setTimeout(() => {
                this.getFileList(), console.log(99);
            }, 100);
        },
        // 每行点击   elk 
        addSubAccount(row) {
            console.log(row, this.result_return_show);

            (this.details.rec_id = row.REC_ID),
            (this.details.index = row.INDEX),
            (this.details.msgtype = row.MSGTYPE),
            (this.details.INDEX_ID = row.INDEX_ID);
            // this.details.col1= this.col1,
            console.log(this.details, "this.details,这是传的数据");

            // this.loading = true;
            this.abstract2 = false;
            this.reason2 = false;
            this.matter2 = false;
            this.original2 = false;
            this.print2 = false;




            if (this.authority_to_judge.read == 1) {
                this.loading = true;
                this.getFileList();

            } else {
                this.$message({

                    message: `${this.$t("tan.reading_pre")}`,
                    type: "error",
                });
            }

        },
        // 每行点击   自定义隔离列表
        addSubAccount_prav(row) {
            console.log(row, this.result_return_show);

            (this.details.rec_id = row.REC_ID),
            (this.details.index = row.INDEX),
            (this.details.msgtype = row.MSGTYPE),
            (this.details.INDEX_ID = row.INDEX_ID);
            // this.details.col1= this.col1,
            console.log(this.details, "this.details,这是传的数据");

            // this.loading = true;
            this.abstract2 = false;
            this.reason2 = false;
            this.matter2 = false;
            this.original2 = false;
            this.print2 = false;

            if (this.priv_json.read) {
                this.loading = true;
                console.log(this.priv_json)
                this.getFileList();

            } else {
                this.$message({

                    message: `${this.$t("tan.reading_pre")}`,
                    type: "error",
                });
            }
        },
        // 批量放行

        bulkpass() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请至少勾选一项，再进行操作",
                    type: "warning",
                });
                return;
            } else {
                this.$confirm(`${this.$t("anti_gs1_tan.pass_email")}`, {
                        confirmButtonText: `${this.$t("tan.confirm")}`,
                        cancelButtonText: `${this.$t("tan.cancel")}`,
                        type: "warning",
                    })
                    .then(() => {
                        this.loading = true;

                        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                        console.log(sid);
                        // console.log(this)
                        // 获取表单数据,搜索条件
                        (this.col_search.totalnums = ""), (this.col_search.page = 1);
                        let col = JSON.stringify(this.col_search);

                        var arr = this.multipleSelection;
                        // console.log(arr, "全选后，获取的数组");
                        let multis = [];
                        for (var i = 0; i < arr.length; i++) {
                            multis.push(arr[i].SEL_ID);
                        }
                        console.log(multis, "选中后的批量放行id", col);
                        let multis1 = JSON.stringify(multis);
                        let str = this.$qs.stringify({
                            __mode: "list_elk_rejectmail",
                            sid: sid,
                            col: col,

                            bulkpassflag: 1,
                            msg_json: multis1,
                        });
                        // console.log(str,'5555555555')
                        this.$axios
                            .post("/api/adm/cgi/elkspam.cgi", str)
                            .then((res) => {
                                console.log(res);
                                if (!res) {
                                    this.loading = false;
                                } else if (!res.data.fmstatus) {
                                    alert(res.data);
                                } else if (res.data.fmstatus.code == "2") {
                                    alert(res.data.fmstatus.errmsg);
                                    this.loading = false;
                                } else if (res.data.fmstatus.code == "3") {
                                    alert(res.data.fmstatus.errmsg);
                                    this.$router.push({
                                        name: "login",
                                    });
                                } else {

                                    this.fileList1 = res.data.ret.datalist;
                                    this.fileListnum = this.fileList1.slice(0, 20);


                                    setTimeout(() => {

                                        this.loadFile_list()
                                    }, 10);
                                    this.clearSelect()
                                    this.totalnums = res.data.ret.col.totalnums;
                                    this.page = res.data.ret.col.page;
                                    this.loading = false;

                                }
                            })

                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: `${this.$t("anti_gs1_tan.pass_email_cancel")}`,
                        });
                    });

            }

        },

        // 全部下载
        openPostWindow() {
            if (this.$root.jurisdiction.only_query != 0 && this.authority_to_judge.download_message == 1) {
                if (this.multipleSelection.length === 0) {
                    this.$message({
                        message: "请至少勾选一项，再进行操作",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm(`${this.$t("anti_gs1_tan.down_load")}`, {
                            confirmButtonText: `${this.$t("tan.confirm")}`,
                            cancelButtonText: `${this.$t("tan.cancel")}`,
                            type: "warning",
                        })
                        .then(() => {
                            var arr = this.multipleSelection;
                            console.log(arr, "全选后，获取的数组");
                            let multis = [];
                            for (var i = 0; i < arr.length; i++) {
                                multis.push(arr[i].SEL_ID);
                            }
                            // console.log(multis, "选中后的id");

                            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                            var tempForm = document.createElement("form");
                            tempForm.id = "tempForm1";
                            tempForm.method = "post";
                            tempForm.action = "/api/adm/cgi/elkspam.cgi?";
                            tempForm.target = "_blank"; //打开新页面
                            var hideInput1 = document.createElement("input");
                            hideInput1.type = "hidden";
                            hideInput1.name = "__mode"; //后台要接受这个参数来取值
                            hideInput1.value = "elk_spam_downzip"; //后台实际取到的值
                            var hideInput2 = document.createElement("input");
                            hideInput2.type = "hidden";
                            hideInput2.name = "sid";
                            hideInput2.value = `${sid}`;
                            var hideInput3 = document.createElement("input");
                            hideInput3.type = "hidden";
                            hideInput3.name = "msg_json";
                            hideInput3.value = `${multis}`;
                            // 这里就是如果需要第二个参数的时候可以自己再设置;
                            tempForm.appendChild(hideInput1); //tempForm.appendChild(hideInput2);
                            tempForm.appendChild(hideInput2); //tempForm.appendChild(hideInput2);
                            tempForm.appendChild(hideInput3); //tempForm.appendChild(hideInput2);
                            if (document.all) {
                                tempForm.attachEvent("onsubmit", function() {}); //IE
                            } else {
                                // var subObj = tempForm.addEventListener("submit", function () {}, false); //firefox
                            }
                            document.body.appendChild(tempForm);
                            if (document.all) {
                                tempForm.fireEvent("onsubmit");
                            } else {
                                tempForm.dispatchEvent(new Event("submit"));
                            }
                            tempForm.submit();
                            document.body.removeChild(tempForm);
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: `${this.$t("anti_gs1_tan.down_load_cancel")}`,
                            });
                        });
                }
            } else {
                this.$message({

                    message: `${this.$t("tan.not_pre")}`,
                    type: "error",
                });
            }
        },
        //  自定义列表全部下载
        openPostWindow_custom() {
            // if (this.$root.jurisdiction.only_query != 0) {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请至少勾选一项，再进行操作",
                    type: "warning",
                });
                return;
            } else {
                this.$confirm(`${this.$t("anti_gs1_tan.down_load")}`, {
                        confirmButtonText: `${this.$t("tan.confirm")}`,
                        cancelButtonText: `${this.$t("tan.cancel")}`,
                        type: "warning",
                    })
                    .then(() => {
                        var arr = this.multipleSelection;
                        console.log(arr, "全选后，获取的数组");
                        let multis = [];
                        for (var i = 0; i < arr.length; i++) {
                            multis.push(arr[i].SEL_ID);
                        }
                        // console.log(multis, "选中后的id");

                        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                        var tempForm = document.createElement("form");
                        tempForm.id = "tempForm1";
                        tempForm.method = "post";
                        tempForm.action = "/api/adm/cgi/elkspam.cgi?";
                        tempForm.target = "_blank"; //打开新页面
                        var hideInput1 = document.createElement("input");
                        hideInput1.type = "hidden";
                        hideInput1.name = "__mode"; //后台要接受这个参数来取值
                        hideInput1.value = "elk_spam_downzip"; //后台实际取到的值
                        var hideInput2 = document.createElement("input");
                        hideInput2.type = "hidden";
                        hideInput2.name = "sid";
                        hideInput2.value = `${sid}`;
                        var hideInput3 = document.createElement("input");
                        hideInput3.type = "hidden";
                        hideInput3.name = "msg_json";
                        hideInput3.value = `${multis}`;
                        // 这里就是如果需要第二个参数的时候可以自己再设置;
                        tempForm.appendChild(hideInput1); //tempForm.appendChild(hideInput2);
                        tempForm.appendChild(hideInput2); //tempForm.appendChild(hideInput2);
                        tempForm.appendChild(hideInput3); //tempForm.appendChild(hideInput2);
                        if (document.all) {
                            tempForm.attachEvent("onsubmit", function() {}); //IE
                        } else {
                            // var subObj = tempForm.addEventListener("submit", function () {}, false); //firefox
                        }
                        document.body.appendChild(tempForm);
                        if (document.all) {
                            tempForm.fireEvent("onsubmit");
                        } else {
                            tempForm.dispatchEvent(new Event("submit"));
                        }
                        tempForm.submit();
                        document.body.removeChild(tempForm);
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: `${this.$t("anti_gs1_tan.down_load_cancel")}`,
                        });
                    });
            }
            // }
        },
        downloadExcel() {
            this.$confirm("确定下载列表文件?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.excelData = this.selectData; //你要导出的数据list。
                    this.exportExcel();
                })
                .catch(() => {});
        },

        // exportExcel() {
        //     /* 从表生成工作簿对象 */
        //     var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
        //     /* 获取二进制字符串作为输出 */
        //     var wbout = XLSX.write(wb, {
        //         bookType: "xlsx",
        //         bookSST: true,
        //         type: "array",
        //     });
        //     try {
        //         FileSaver.saveAs(
        //             //Blob 对象表示一个不可变、原始数据的类文件对象。
        //             //Blob 表示的不一定是JavaScript原生格式的数据。
        //             //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
        //             //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
        //             new Blob([wbout], {
        //                 type: "application/octet-stream",
        //             }),
        //             //设置导出文件名称
        //             "sheetjs.xlsx"
        //         );
        //     } catch (e) {
        //         if (typeof console !== "undefined") console.log(e, wbout);
        //     }
        //     return wbout;
        // },

        //  getdatatime() {
        //   //默认显示今天
        //   this.value2 = new Date();
        // },
        // 格式化时间，获取当前时间的一个月后的时间值
        Date() {
            var seperator1 = "-";

            var data = new Date();
            var Da = new Date(data.getTime());
            // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
            // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
            // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
            // var Da = new Date()
            var year = Da.getFullYear();
            var month = Da.getMonth() + 1;
            var hour = Da.getHours();
            var minutes = Da.getMinutes();
            var seconds = Da.getSeconds();
            var strDate = Da.getDate();
            if (hour >= 1 && hour <= 9) {
                hour = "0" + hour;
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            if (seconds >= 1 && seconds <= 9) {
                seconds = "0" + seconds;
            }
            if (minutes >= 0 && minutes <= 9) {
                minutes = "0" + minutes;
            }
            return (
                year +
                seperator1 +
                month +
                seperator1 +
                strDate +
                " " +
                hour +
                ":" +
                minutes +
                ":" +
                seconds
            );
        },
        // 七天前日期
        convertToLateDate() {
            var data = new Date();
            var Da = new Date(data.getTime() - 24 * 60 * 60 * 1000 * 7);
            var seperator1 = "-";
            // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
            // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
            // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
            // var Da = new Date()
            // var y = Da.getFullYear();
            // var m = Da.getMonth() + 1;
            // var d = Da.getDate();
            // var H = Da.getHours();
            // var mm = Da.getMinutes();
            // m = m < 10 ? "0" + m : m;
            // d = d < 10 ? "0" + d : d;
            // H = H < 10 ? "0" + H : H;
            // return y + "-" + m + "-" + d + " " + H + ":" + mm;
            var year = Da.getFullYear();
            var month = Da.getMonth() + 1;
            var hour = Da.getHours();
            var minutes = Da.getMinutes();
            var seconds = Da.getSeconds();
            var strDate = Da.getDate();
            if (hour >= 1 && hour <= 9) {
                hour = "0" + hour;
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            if (seconds >= 1 && seconds <= 9) {
                seconds = "0" + seconds;
            }
            if (minutes >= 0 && minutes <= 9) {
                minutes = "0" + minutes;
            }
            return (
                year +
                seperator1 +
                month +
                seperator1 +
                strDate +
                " " +
                hour +
                ":" +
                minutes +
                ":" +
                seconds
            );
        },

        // 表格选中值
        handleSelectionChange(val) {
            // console.log(val)
            this.multipleSelection = val;

            console.log(this.multipleSelection, "table 框选中的值");
            // console.log(this.table);
        },

        getRowKeys(row) {
            //  console.log(row.INDEX_ID)
            return row.REC_ID; // id为列表数据的唯一标识
        },
        clearSelect() {
            this.$refs.multipleTable.clearSelection()
        },
        //全选
        speedupData() {
            var arr = this.multipleSelection;
            // console.log(arr, "全选后，获取的数组");
            let multis = [];
            for (var i = 0; i < arr.length; i++) {
                multis.push(arr[i].SEL_ID);
            }
            console.log(multis, "选中后的id");

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // let msg=JSON.stringify(multis)
            let __mode = "elk_spam_downzip";
            console.log(__mode);

            // window.open(
            //   `https://211.100.61.212/adm/cgi/elkspam.cgi?__mode=${__mode}&sid=${sid}&msg_json=${multis}&is_elk=1`
            // );
            this.$refs.multipleTable.clearSelection(); //操作完成清除勾选框
        },

        // 更多
        xians: function() {
            this.xian = !this.xian;

            if (this.xian) {
                this.geng = false;
                this.geng1 = true;
            } else {
                this.geng = true;
                this.geng1 = false;
            }
        },
        // 页面加载完成时，
        getFileList_2() {
            // this.default_num()
            this.loading = true;
            this.default_num()
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件
            // let col = this.col;

            let col = this.col_search;

            console.log(col, "点击列表后返回的col值");
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/elkspam.cgi", {
                    params: {
                        __mode: " list_elk_rejectmail",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(col, "传的col值");
                    this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                    if (!res) {
                        this.loading = false;
                    } else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList1 = res.data.ret.datalist;
                        this.fileListnum = this.fileList1.slice(0, 20);


                        setTimeout(() => {

                            this.loadFile_list()
                        }, 10);
                        // 总条数
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;

                        this.col_search = res.data.ret.col;
                        this.restore_defaults();

                        if (this.loading_time == 2) {
                            this.load_next_time();
                        } else if (this.loading_time == 1) {
                            this.load_up_time();
                        } else if (this.loading_time == 3) {
                            this.load_up_time();
                        } else if (this.loading_time == 4) {

                            setTimeout(() => {
                                this.get_top();
                            }, 11);
                        } else if (this.loading_time == 5) {
                            this.load_up_time_next();
                        }
                    }
                });
        },
        restore_defaults() {
            this.abstract2 = false;
            this.reason2 = false;
            this.matter2 = false;
            this.original2 = false;
            this.print2 = false;
            this.detail_show = false;
        },
        splict_arr(arr, len) {

            let result = [];

            result = arr.slice(0, len)

            // console.log(result, '结果是什么呢')
            setTimeout(() => {
                this.arr_add(arr)
            }, 3)


            return result;
        },
        arr_add(arr) {
            for (let i = 20; i < arr.length; i++) {
                this.fileList1.push(arr[i])
            }
            // this.loading = false;

            // console.log('到这里来了')
            // console.log(this.fileList1)
        },
        default_num() {
            this.num_load = 20;

        },

        loadFile_list() {
            if (this.num_load <= (this.size)) {
                if (this.num_load < 20 || this.num_load >= this.size) {
                    this.num_load += 20

                } else {
                    this.num_load += (this.size - 20)

                }


                let arr_load = this.fileList1;


                let num = this.num_load;


                this.fileListnum = arr_load.slice(0, num);
                console.log(this.fileListnum.length)


                console.log(this.num_load, this.fileList1.length)

            }
        },

        // 数据

        getFileList_1() {
            this.default_num()
            this.loading = true;
            this.refresh_loading = true;
            // console.log(this.refresh_loading)
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let col = this.col;
            console.log(col, "这是加载的时候col 的值");
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/elkspam.cgi", {
                    params: {
                        __mode: " list_elk_rejectmail",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(col, "传的col值");
                    this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                    if (!res) {
                        this.loading = false;
                        this.refresh_loading = false
                    } else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;
                        this.refresh_loading = false
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;
                        this.refresh_loading = false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.list_custom_two = 1
                        this.list_custom_one = 0
                        this.fileList1 = res.data.ret.datalist;
                        this.fileListnum = this.fileList1.slice(0, 20);


                        setTimeout(() => {

                            this.loadFile_list()
                        }, 10);
                        console.log(this.perform_load, '我是加载完成后的判断')
                            // let fileListnum = res.data.ret.datalist;
                            // this.fileList1 = this.splict_arr(fileListnum, 20);
                        this.refresh_loading = false
                        this.loading = false;
                        this.ping_an_show = res.data.ret.SYS_AREA_REJ_LIST_SHOW_LESS == 1 ? 1 : 0;
                        this.q_page_size = res.data.ret.q_pagesize;
                        console.log(this.ping_an_show)
                            // 自定义隔离列表
                        this.priv_json = res.data.ret.PRIV_JSON
                        this.data_forword = res.data.ret.data_forword;
                        this.data_forword_address = res.data.ret.data_forword_address;

                        console.log(this.priv_json)
                        if (
                            res.data.ret.col.spam_reason == "newrule" ||
                            res.data.ret.col.spam_reason == "combrule"
                        ) {
                            this.subwhy = 1;
                        }
                        this.data_bulkpass_show = res.data.ret.SYS_DISABLE_PASS_ELKSPAM;

                        this.data_can_delete_show = res.data.ret.SYS_GATE_SPAM_CAN_DELETE;

                        this.printtype_arr = res.data.ret.q_printtype;
                        this.limit_cn_old = res.data.ret.col.limit_cn
                            // 总条数
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                        this.linkunti = res.data.ret.col.linkunti;
                        this.bccunti = res.data.ret.col.bccunti;
                        this.athunti = res.data.ret.col.athunti;
                        // console.log(this.page)
                        this.haspass1 = res.data.ret.q_haspass
                        this.minionhost = res.data.ret.q_minion_host;
                        // this.type1 = res.data.ret.q_spam_reason;
                        // 节点
                        this.minionhost = res.data.ret.q_minion_host;
                        //  类型
                        this.type1 = res.data.ret.q_type;
                        //  原因
                        this.spamreason = res.data.ret.q_spam_reason;
                        this.q_order_type_arr = res.data.ret.q_order_type;
                        this.q_order_sort_arr = res.data.ret.q_order_sort;

                        // for (let i = 0; i < this.fileList1.length; ++i) {
                        //     this.fileList1[i].SHOW_MORE = '展示更多'
                        // }
                        // 页面加载完成后渲染日期
                        if (this.search_time == 0) {
                            this.col.startdate = res.data.ret.q_date;
                        }

                        this.istls_arr = res.data.ret.q_yes_no;
                        this.isout_arr = res.data.ret.q_isout;
                        this.date_type = res.data.ret.col.startdate;
                        this.col_search = res.data.ret.col;

                        console.log(this.col_search, "后台返回数据col");
                        this.$nextTick(() => {
                            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
                        });
                        // console.log(this.$refs.multipleTable)

                    }
                });
        },

        // 打开搜素
        tanSend() {
            if (this.geng1 == true) {
                this.geng = true;
                this.geng1 = false;
                this.xian = false;
            }
            // this.xians()
            // if((this.col.nbattach!='' ||this.col.nblink!=''||this.col.nbbcc!='')){
            // //    console.log(this.col.nbattach)
            //     if(this.col.achunit=='' || this.col.linkunti || this.col.bccunti){
            //         alert('请输入')
            //     }
            // }
            this.default_num()
            this.loading = true;
            // this.page = 1
            const col = {
                order_type: this.col.q_order_type,
                order_sort: this.col.q_order_sort,
                linkunit: this.col.linkunit,
                bccunit: this.col.bccunit,
                achunit: this.col.achunit,
                istls: this.col.istls,
                isl: this.col.isl,
                nblink: this.col.nblink,
                nbbcc: this.col.nbbcc,
                nbattach: this.col.nbattach,
                isout: this.col.isout,
                subject: this.col.subject,
                url: this.col.url,
                envfrom: this.col.envfrom,
                envrcpt: this.col.envrcpt,
                mid: this.col.mid,
                ip: this.col.ip,
                attach: this.col.attach,
                hdrfrom: this.col.hdrfrom,
                hdrto: this.col.hdrto,
                body: this.col.body,
                type: this.col.type,
                haspass: this.col.haspass,
                min_size: this.col.min_size,
                max_size: this.col.max_size,
                min_size_unit: this.col.min_size_unit,
                max_size_unit: this.col.max_size_unit,
                min_attsize: this.col.min_attsize,
                max_attsize: this.col.max_attsize,
                min_attsize_unit: this.col.min_attsize_unit,
                max_attsize_unit: this.col.max_attsize_unit,
                spam_reason: this.col.spam_reason,
                startdate: this.col.startdate,
                subwhy: this.col.subwhy,
                minion_host: this.col.minion_host,
                page: 1,
                pagesize: this.size,
                userrule: this.userrule,
                user_rec: this.user_rec,
            };
            let col2 = col;

            // Vue.set(this.default_sort)
            // console.log(col2, "搜索传值");
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            this.$axios
                .get("/api/adm/cgi/elkspam.cgi", {
                    params: {
                        __mode: "list_elk_rejectmail",
                        sid: sid,
                        col: col2,
                    },
                })
                .then((res) => {
                    // this.loading = true;
                    if (!res) {
                        this.loading = false;
                    } else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;
                    } else if (res.data.fmstatus.code == "2") {
                        this.loading = false;

                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        console.log(res);
                        if (
                            res.data.ret.col.spam_reason == "newrule" ||
                            res.data.ret.col.spam_reason == "combrule"
                        ) {
                            this.subwhy = 1;
                        }
                        // this.col1 = this.col;
                        // let col1 = this.col1;
                        // console.log(col1);
                        // this.page = 1
                        // this.pagesize = 50
                        // this.xian=false
                        if (this.col.q_order_type == 'datetime') {
                            this.default_q_order_type = 'AC_DATE';
                        } else if (this.col.q_order_type == 'peerip') {
                            this.default_q_order_type = 'IP';
                        } else if (this.default_q_order_type == 'envfrom') {
                            this.default_q_order_type = "ENVFROM";
                        } else if (this.default_q_order_type == 'envrcpt') {
                            this.default_q_order_type = 'ENVRCPT';
                        } else if (this.default_q_order_type == 'subject') {
                            this.default_q_order_type = 'SUBJECT';
                        } else if (this.default_q_order_type == 'msgsize') {
                            this.default_q_order_type = 'SIZE';
                        }
                        if (this.col.q_order_sort == 'desc') {
                            this.default_q_order_sort = "descending";
                        } else if (this.col.q_order_sort == 'asc') {
                            this.default_q_order_sort = "ascending";
                        }
                        // this.$refs.multipleTable.sort()
                        this.default_sort = { prop: this.default_q_order_type, order: this.default_q_order_sort };
                        // this.$forceUpdate()
                        // console.log(this.default_sort, this.$refs.multipleTable.sort())
                        this.search_time = 1;
                        this.fileList1 = res.data.ret.datalist;
                        this.fileListnum = this.fileList1.slice(0, 20);


                        setTimeout(() => {

                            this.loadFile_list()
                        }, 10);

                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                        this.loading = false;
                        this.$nextTick(() => {
                            this.default_sort = { prop: this.default_q_order_type, order: this.default_q_order_sort };
                            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
                        });
                        this.col_search = res.data.ret.col;
                        this.clearSelect()
                        console.log(this.col_search, "后台返回数据col，搜索后");
                    }
                });

        },
        // 各行变色
        tableRowClassName({ rowIndex }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },

        // 每页显示多少条 -- 切换
        handleSizeChange(val) {
            this.col = this.col_search;
            console.log(this.col, "给后台返回数据1");
            this.col.pagesize = val;

            console.log(this.col, "给后台返回数据2");

            this.getFileList_1();
            this.clearSelect()
        },
        // 当前第几页
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            console.log(this.col.startdate, this.col_search);

            this.col = this.col_search;
            this.col.page = val;
            console.log(this.col, "给后台返回数据2");

            this.getFileList_1();
            this.clearSelect()
        },
    },

}